// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptProposalData, AcceptProposalErrors, AcceptProposalResponses, ActivateInvestorData, ActivateInvestorErrors, ActivateInvestorResponses, AdminCreateInvitationData, AdminCreateInvitationErrors, AdminCreateInvitationResponses, AdminDeleteInvitationData, AdminDeleteInvitationErrors, AdminDeleteInvitationResponses, AdminDeleteMembershipData, AdminDeleteMembershipErrors, AdminDeleteMembershipResponses, AdminDeleteOrganizationData, AdminDeleteOrganizationErrors, AdminDeleteOrganizationInvitationData, AdminDeleteOrganizationInvitationErrors, AdminDeleteOrganizationInvitationResponses, AdminDeleteOrganizationResponses, AdminInviteUserData, AdminInviteUserErrors, AdminInviteUserResponses, AdminResendInvitationData, AdminResendInvitationErrors, AdminResendInvitationResponses, AdminUpdateMembershipData, AdminUpdateMembershipErrors, AdminUpdateMembershipResponses, AdminUpdateOrganizationData, AdminUpdateOrganizationErrors, AdminUpdateOrganizationResponses, AuthLoginUserData, AuthLoginUserErrors, AuthLoginUserResponses, AuthLogoutData, AuthLogoutErrors, AuthLogoutResponses, AuthRefreshTokenData, AuthRefreshTokenErrors, AuthRefreshTokenResponses, BulkDeleteClassificationsData, BulkDeleteClassificationsErrors, BulkDeleteClassificationsResponses, BulkReclassifyClassificationsData, BulkReclassifyClassificationsErrors, BulkReclassifyClassificationsResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, CommitFiscalQuotaConsolidationData, CommitFiscalQuotaConsolidationErrors, CommitFiscalQuotaConsolidationResponses, CompleteInvitationData, CompleteInvitationErrors, CompleteInvitationResponses, ConfirmEmailVerificationData, ConfirmEmailVerificationErrors, ConfirmEmailVerificationResponses, CreateBankAccountData, CreateBankAccountErrors, CreateBankAccountResponses, CreateBeneficiaryData, CreateBeneficiaryErrors, CreateBeneficiaryResponses, CreateCompanyInvestorData, CreateCompanyInvestorErrors, CreateCompanyInvestorResponses, CreateFiscalQuotaData, CreateFiscalQuotaErrors, CreateFiscalQuotaResponses, CreateIndividualInvestorData, CreateIndividualInvestorErrors, CreateIndividualInvestorResponses, CreateInvestmentData, CreateInvestmentErrors, CreateInvestmentResponses, CreateInvestorLegalRepresentativeData, CreateInvestorLegalRepresentativeErrors, CreateInvestorLegalRepresentativeResponses, CreateInvitationData, CreateInvitationErrors, CreateInvitationResponses, CreateLegalRepresentativeData, CreateLegalRepresentativeErrors, CreateLegalRepresentativeResponses, CreateOrganizationData, CreateOrganizationErrors, CreateOrganizationResponses, CreateProjectForBeneficiaryData, CreateProjectForBeneficiaryErrors, CreateProjectForBeneficiaryResponses, CreateProjectPosterData, CreateProjectPosterErrors, CreateProjectPosterResponses, CreateProjectsBulkForBeneficiaryData, CreateProjectsBulkForBeneficiaryErrors, CreateProjectsBulkForBeneficiaryResponses, CreateProposalData, CreateProposalErrors, CreateProposalResponses, CreateTemplateData, CreateTemplateErrors, CreateTemplateResponses, CreateUploadSessionData, CreateUploadSessionErrors, CreateUploadSessionResponses, CreateUserData, CreateUserErrors, CreateUserResponses, DeactivateInvestorData, DeactivateInvestorErrors, DeactivateInvestorResponses, DeclineProposalData, DeclineProposalErrors, DeclineProposalResponses, DeleteAllNotificationsData, DeleteAllNotificationsErrors, DeleteAllNotificationsResponses, DeleteBankAccountData, DeleteBankAccountErrors, DeleteBankAccountResponses, DeleteBeneficiaryData, DeleteBeneficiaryDocumentData, DeleteBeneficiaryDocumentErrors, DeleteBeneficiaryDocumentResponses, DeleteBeneficiaryErrors, DeleteBeneficiaryResponses, DeleteClassificationData, DeleteClassificationErrors, DeleteClassificationResponses, DeleteFiscalQuotaData, DeleteFiscalQuotaErrors, DeleteFiscalQuotaResponses, DeleteInvestmentData, DeleteInvestmentDocumentData, DeleteInvestmentDocumentErrors, DeleteInvestmentDocumentResponses, DeleteInvestmentErrors, DeleteInvestmentResponses, DeleteInvestorData, DeleteInvestorDocumentData, DeleteInvestorDocumentErrors, DeleteInvestorDocumentResponses, DeleteInvestorErrors, DeleteInvestorLegalRepresentativeData, DeleteInvestorLegalRepresentativeErrors, DeleteInvestorLegalRepresentativeResponses, DeleteInvestorResponses, DeleteLegalRepresentativeData, DeleteLegalRepresentativeErrors, DeleteLegalRepresentativeResponses, DeleteNotificationData, DeleteNotificationErrors, DeleteNotificationResponses, DeleteOrganizationDocumentData, DeleteOrganizationDocumentErrors, DeleteOrganizationDocumentResponses, DeleteProjectData, DeleteProjectDocumentData, DeleteProjectDocumentErrors, DeleteProjectDocumentResponses, DeleteProjectErrors, DeleteProjectPosterData, DeleteProjectPosterErrors, DeleteProjectPosterResponses, DeleteProjectResponses, DeleteTemplateData, DeleteTemplateErrors, DeleteTemplateResponses, DownloadAeatDocumentsData, DownloadAeatDocumentsErrors, DownloadAeatDocumentsResponses, DownloadBeneficiaryDocumentData, DownloadBeneficiaryDocumentErrors, DownloadBeneficiaryDocumentResponses, DownloadInvestmentDocumentData, DownloadInvestmentDocumentErrors, DownloadInvestmentDocumentResponses, DownloadInvestorDocumentData, DownloadInvestorDocumentErrors, DownloadInvestorDocumentResponses, DownloadMyInvestmentDocumentData, DownloadMyInvestmentDocumentErrors, DownloadMyInvestmentDocumentResponses, DownloadOrganizationDocumentData, DownloadOrganizationDocumentErrors, DownloadOrganizationDocumentResponses, DownloadProjectDocumentData, DownloadProjectDocumentErrors, DownloadProjectDocumentResponses, DuplicateTemplateData, DuplicateTemplateErrors, DuplicateTemplateResponses, ExportBeneficiariesData, ExportBeneficiariesErrors, ExportBeneficiariesResponses, ExportClassificationsData, ExportClassificationsErrors, ExportClassificationsResponses, ExportInvestmentsData, ExportInvestmentsErrors, ExportInvestmentsResponses, ExportInvestorsData, ExportInvestorsErrors, ExportInvestorsResponses, ExtendReservationData, ExtendReservationErrors, ExtendReservationResponses, GenerateExpenseAuditData, GenerateExpenseAuditErrors, GenerateExpenseAuditResponses, GetBeneficiariesData, GetBeneficiariesErrors, GetBeneficiariesResponses, GetBeneficiaryDetailsData, GetBeneficiaryDetailsErrors, GetBeneficiaryDetailsResponses, GetBeneficiaryDocumentData, GetBeneficiaryDocumentErrors, GetBeneficiaryDocumentResponses, GetBeneficiaryMetricsData, GetBeneficiaryMetricsErrors, GetBeneficiaryMetricsResponses, GetBeneficiaryProjectsData, GetBeneficiaryProjectsErrors, GetBeneficiaryProjectsResponses, GetCatalogData, GetCatalogErrors, GetCatalogResponses, GetClassificationData, GetClassificationErrors, GetClassificationFileData, GetClassificationFileErrors, GetClassificationFileResponses, GetClassificationLocksData, GetClassificationLocksErrors, GetClassificationLocksResponses, GetClassificationPipelineStatusData, GetClassificationPipelineStatusErrors, GetClassificationPipelineStatusResponses, GetClassificationResponses, GetClassificationStatsData, GetClassificationStatsErrors, GetClassificationStatsResponses, GetClassificationSummaryData, GetClassificationSummaryErrors, GetClassificationSummaryResponses, GetCompanyInvestorData, GetCompanyInvestorErrors, GetCompanyInvestorResponses, GetContractDetailsData, GetContractDetailsErrors, GetContractDetailsResponses, GetContractDocumentData, GetContractDocumentErrors, GetContractDocumentResponses, GetContractStatsData, GetContractStatsErrors, GetContractStatsResponses, GetCurrentOrganizationData, GetCurrentOrganizationErrors, GetCurrentOrganizationResponses, GetDashboardMetricsData, GetDashboardMetricsErrors, GetDashboardMetricsResponses, GetDashboardStatsData, GetDashboardStatsErrors, GetDashboardStatsResponses, GetDocumentSigningUrlData, GetDocumentSigningUrlErrors, GetDocumentSigningUrlResponses, GetFiscalYearSummaryData, GetFiscalYearSummaryErrors, GetFiscalYearSummaryResponses, GetIndividualInvestorData, GetIndividualInvestorErrors, GetIndividualInvestorResponses, GetInvestmentData, GetInvestmentDocumentData, GetInvestmentDocumentErrors, GetInvestmentDocumentResponses, GetInvestmentErrors, GetInvestmentMetricsData, GetInvestmentMetricsErrors, GetInvestmentMetricsResponses, GetInvestmentResponses, GetInvestorDocumentData, GetInvestorDocumentErrors, GetInvestorDocumentResponses, GetInvestorMetricsData, GetInvestorMetricsErrors, GetInvestorMetricsResponses, GetInvestorMusicDeductionSummaryData, GetInvestorMusicDeductionSummaryErrors, GetInvestorMusicDeductionSummaryResponses, GetInvitationsData, GetInvitationsErrors, GetInvitationsResponses, GetMeData, GetMeErrors, GetMembersData, GetMembersErrors, GetMembersResponses, GetMeResponses, GetMyDashboardData, GetMyDashboardErrors, GetMyDashboardResponses, GetMyDocumentsPortfolioData, GetMyDocumentsPortfolioErrors, GetMyDocumentsPortfolioResponses, GetMyInvestmentData, GetMyInvestmentErrors, GetMyInvestmentResponses, GetMyInvitationsData, GetMyInvitationsErrors, GetMyInvitationsResponses, GetMyMembershipsData, GetMyMembershipsErrors, GetMyMembershipsResponses, GetMyPendingActionsData, GetMyPendingActionsErrors, GetMyPendingActionsResponses, GetMyProfileData, GetMyProfileErrors, GetMyProfileResponses, GetNotificationData, GetNotificationErrors, GetNotificationResponses, GetNotificationsData, GetNotificationsErrors, GetNotificationsResponses, GetNotificationStatsData, GetNotificationStatsErrors, GetNotificationStatsResponses, GetOrganizationByUuidData, GetOrganizationByUuidErrors, GetOrganizationByUuidResponses, GetOrganizationDocumentData, GetOrganizationDocumentErrors, GetOrganizationDocumentResponses, GetOrganizationUsageData, GetOrganizationUsageErrors, GetOrganizationUsageResponses, GetOrgEntitlementsData, GetOrgEntitlementsErrors, GetOrgEntitlementsResponses, GetProjectData, GetProjectDocumentData, GetProjectDocumentErrors, GetProjectDocumentResponses, GetProjectErrors, GetProjectPosterData, GetProjectPosterErrors, GetProjectPosterResponses, GetProjectResponses, GetProjectsData, GetProjectsErrors, GetProjectsResponses, GetProposalData, GetProposalErrors, GetProposalResponses, GetSuppliersAnalyticsData, GetSuppliersAnalyticsErrors, GetSuppliersAnalyticsResponses, GetTaxBreakdownData, GetTaxBreakdownErrors, GetTaxBreakdownResponses, GetTemplateCompatibilityData, GetTemplateCompatibilityErrors, GetTemplateCompatibilityResponses, GetTemplateData, GetTemplateErrors, GetTemplateImagePreviewData, GetTemplateImagePreviewErrors, GetTemplateImagePreviewResponses, GetTemplateResponses, GetUploadSessionStatusData, GetUploadSessionStatusErrors, GetUploadSessionStatusResponses, GetUserByUuidData, GetUserByUuidErrors, GetUserByUuidResponses, GetUserMembershipsData, GetUserMembershipsErrors, GetUserMembershipsResponses, GetWorkforceAnalyticsData, GetWorkforceAnalyticsErrors, GetWorkforceAnalyticsResponses, GrantEntitlementData, GrantEntitlementErrors, GrantEntitlementResponses, HandleDocusealWebhookData, HandleDocusealWebhookErrors, HandleDocusealWebhookResponses, HandleDocusignWebhookData, HandleDocusignWebhookErrors, HandleDocusignWebhookResponses, HealthCheckData, HealthCheckResponses, InviteInvestorToHubData, InviteInvestorToHubErrors, InviteInvestorToHubResponses, ListAllOrganizationsData, ListAllOrganizationsErrors, ListAllOrganizationsResponses, ListBankAccountsData, ListBankAccountsErrors, ListBankAccountsResponses, ListBeneficiaryDocumentsByFiscalQuotaData, ListBeneficiaryDocumentsByFiscalQuotaErrors, ListBeneficiaryDocumentsByFiscalQuotaResponses, ListBeneficiaryDocumentsData, ListBeneficiaryDocumentsErrors, ListBeneficiaryDocumentsResponses, ListClassificationsData, ListClassificationsErrors, ListClassificationsResponses, ListContractsData, ListContractsErrors, ListContractsResponses, ListEntitlementsData, ListEntitlementsErrors, ListEntitlementsResponses, ListFiscalQuotasData, ListFiscalQuotasErrors, ListFiscalQuotasResponses, ListInvestmentDocumentsData, ListInvestmentDocumentsErrors, ListInvestmentDocumentsResponses, ListInvestmentsData, ListInvestmentsErrors, ListInvestmentsResponses, ListInvestorDocumentsData, ListInvestorDocumentsErrors, ListInvestorDocumentsResponses, ListInvestorLegalRepresentativesData, ListInvestorLegalRepresentativesErrors, ListInvestorLegalRepresentativesResponses, ListInvestorsData, ListInvestorsErrors, ListInvestorsResponses, ListInvitationsData, ListInvitationsErrors, ListInvitationsResponses, ListLegalRepresentativesData, ListLegalRepresentativesErrors, ListLegalRepresentativesResponses, ListMembersData, ListMembersErrors, ListMembersResponses, ListMyInvestmentDocumentsData, ListMyInvestmentDocumentsErrors, ListMyInvestmentDocumentsResponses, ListMyInvestmentsData, ListMyInvestmentsErrors, ListMyInvestmentsResponses, ListMyProfilesData, ListMyProfilesErrors, ListMyProfilesResponses, ListOrganizationDocumentsData, ListOrganizationDocumentsErrors, ListOrganizationDocumentsResponses, ListProjectDocumentsData, ListProjectDocumentsErrors, ListProjectDocumentsResponses, ListProposalsData, ListProposalsErrors, ListProposalsResponses, ListRuleIdsData, ListRuleIdsErrors, ListRuleIdsResponses, ListTemplatesData, ListTemplatesErrors, ListTemplatesResponses, ListUsersData, ListUsersErrors, ListUsersResponses, MarkAllAsReadData, MarkAllAsReadErrors, MarkAllAsReadResponses, MarkAsReadData, MarkAsReadErrors, MarkAsReadResponses, MarkAsUnreadData, MarkAsUnreadErrors, MarkAsUnreadResponses, PingData, PingResponses, PreviewBeneficiariesExportData, PreviewBeneficiariesExportErrors, PreviewBeneficiariesExportResponses, PreviewClassificationsExportData, PreviewClassificationsExportErrors, PreviewClassificationsExportResponses, PreviewCommunicationContractData, PreviewCommunicationContractErrors, PreviewCommunicationContractResponses, PreviewExpenseAuditData, PreviewExpenseAuditErrors, PreviewExpenseAuditResponses, PreviewFinancingContractData, PreviewFinancingContractErrors, PreviewFinancingContractResponses, PreviewFiscalQuotaConsolidationData, PreviewFiscalQuotaConsolidationErrors, PreviewFiscalQuotaConsolidationResponses, PreviewInvestmentsExportData, PreviewInvestmentsExportErrors, PreviewInvestmentsExportResponses, PreviewInvestorsExportData, PreviewInvestorsExportErrors, PreviewInvestorsExportResponses, PreviewReservationContractData, PreviewReservationContractErrors, PreviewReservationContractResponses, PreviewTemplateData, PreviewTemplateErrors, PreviewTemplateResponses, QueryAgentData, QueryAgentErrors, QueryAgentResponses, ReclassifyClassificationData, ReclassifyClassificationErrors, ReclassifyClassificationResponses, RemoveMembershipData, RemoveMembershipErrors, RemoveMembershipResponses, ResendDocumentData, ResendDocumentErrors, ResendDocumentResponses, ResendInvitationData, ResendInvitationErrors, ResendInvitationResponses, ResetEntitlementQuotaData, ResetEntitlementQuotaErrors, ResetEntitlementQuotaResponses, ResetPasswordData, ResetPasswordErrors, ResetPasswordResponses, ResolveDuplicateData, ResolveDuplicateErrors, ResolveDuplicateResponses, RetryContractDispatchData, RetryContractDispatchErrors, RetryContractDispatchResponses, ReviewBeneficiaryDocumentData, ReviewBeneficiaryDocumentErrors, ReviewBeneficiaryDocumentResponses, ReviewClassificationData, ReviewClassificationErrors, ReviewClassificationResponses, ReviewInvestmentDocumentData, ReviewInvestmentDocumentErrors, ReviewInvestmentDocumentResponses, ReviewInvestorDocumentData, ReviewInvestorDocumentErrors, ReviewInvestorDocumentResponses, ReviewOrganizationDocumentData, ReviewOrganizationDocumentErrors, ReviewOrganizationDocumentResponses, ReviewProjectDocumentData, ReviewProjectDocumentErrors, ReviewProjectDocumentResponses, RevokeInvitationData, RevokeInvitationErrors, RevokeInvitationResponses, SendCommunicationContractData, SendCommunicationContractErrors, SendCommunicationContractResponses, SendFinancingContractData, SendFinancingContractErrors, SendFinancingContractResponses, SendForgotPasswordEmailData, SendForgotPasswordEmailErrors, SendForgotPasswordEmailResponses, SendReservationContractData, SendReservationContractErrors, SendReservationContractResponses, SendResetPasswordEmailData, SendResetPasswordEmailErrors, SendResetPasswordEmailResponses, SendVerifyEmailData, SendVerifyEmailErrors, SendVerifyEmailResponses, SetDefaultMembershipData, SetDefaultMembershipErrors, SetDefaultMembershipResponses, SetPrimaryBankAccountData, SetPrimaryBankAccountErrors, SetPrimaryBankAccountResponses, SetPrimaryInvestorLegalRepresentativeData, SetPrimaryInvestorLegalRepresentativeErrors, SetPrimaryInvestorLegalRepresentativeResponses, SetPrimaryLegalRepresentativeData, SetPrimaryLegalRepresentativeErrors, SetPrimaryLegalRepresentativeResponses, SignUploadBatchData, SignUploadBatchErrors, SignUploadBatchResponses, SubmitFeedbackData, SubmitFeedbackErrors, SubmitFeedbackResponses, SwitchOrganizationData, SwitchOrganizationErrors, SwitchOrganizationResponses, ToggleUserStatusData, ToggleUserStatusErrors, ToggleUserStatusResponses, UpdateBankAccountData, UpdateBankAccountErrors, UpdateBankAccountResponses, UpdateBeneficiaryData, UpdateBeneficiaryDocumentData, UpdateBeneficiaryDocumentErrors, UpdateBeneficiaryDocumentResponses, UpdateBeneficiaryErrors, UpdateBeneficiaryResponses, UpdateClassificationData, UpdateClassificationErrors, UpdateClassificationResponses, UpdateCompanyInvestorData, UpdateCompanyInvestorErrors, UpdateCompanyInvestorResponses, UpdateEntitlementData, UpdateEntitlementErrors, UpdateEntitlementResponses, UpdateFiscalQuotaData, UpdateFiscalQuotaErrors, UpdateFiscalQuotaResponses, UpdateIndividualInvestorData, UpdateIndividualInvestorErrors, UpdateIndividualInvestorResponses, UpdateInvestmentData, UpdateInvestmentDocumentData, UpdateInvestmentDocumentErrors, UpdateInvestmentDocumentResponses, UpdateInvestmentErrors, UpdateInvestmentResponses, UpdateInvestorDocumentData, UpdateInvestorDocumentErrors, UpdateInvestorDocumentResponses, UpdateInvestorLegalRepresentativeData, UpdateInvestorLegalRepresentativeErrors, UpdateInvestorLegalRepresentativeResponses, UpdateLegalRepresentativeData, UpdateLegalRepresentativeErrors, UpdateLegalRepresentativeResponses, UpdateMeData, UpdateMeErrors, UpdateMembershipData, UpdateMembershipErrors, UpdateMembershipResponses, UpdateMeResponses, UpdateMyProfileData, UpdateMyProfileErrors, UpdateMyProfileResponses, UpdateOrganizationData, UpdateOrganizationDocumentData, UpdateOrganizationDocumentErrors, UpdateOrganizationDocumentResponses, UpdateOrganizationErrors, UpdateOrganizationResponses, UpdateProjectData, UpdateProjectDocumentData, UpdateProjectDocumentErrors, UpdateProjectDocumentResponses, UpdateProjectErrors, UpdateProjectResponses, UpdateTemplateData, UpdateTemplateErrors, UpdateTemplateResponses, UploadBeneficiaryDocumentData, UploadBeneficiaryDocumentErrors, UploadBeneficiaryDocumentResponses, UploadInvestmentDocumentData, UploadInvestmentDocumentErrors, UploadInvestmentDocumentResponses, UploadInvestorDocumentData, UploadInvestorDocumentErrors, UploadInvestorDocumentResponses, UploadOrganizationDocumentData, UploadOrganizationDocumentErrors, UploadOrganizationDocumentResponses, UploadPaymentReceiptData, UploadPaymentReceiptErrors, UploadPaymentReceiptResponses, UploadProjectDocumentData, UploadProjectDocumentErrors, UploadProjectDocumentResponses, UploadTemplateImageData, UploadTemplateImageErrors, UploadTemplateImageResponses, VerifyInvitationData, VerifyInvitationErrors, VerifyInvitationResponses, VoidContractData, VoidContractErrors, VoidContractResponses } from './types.gen';
import { zAcceptProposalResponse, zActivateInvestorResponse, zAdminCreateInvitationResponse, zAdminDeleteInvitationResponse, zAdminDeleteMembershipResponse, zAdminDeleteOrganizationInvitationResponse, zAdminDeleteOrganizationResponse, zAdminInviteUserResponse, zAdminResendInvitationResponse, zAdminUpdateMembershipResponse, zAdminUpdateOrganizationResponse, zAuthLoginUserResponse, zAuthLogoutResponse, zAuthRefreshTokenResponse, zBulkDeleteClassificationsResponse2, zBulkReclassifyClassificationsResponse2, zChangePasswordResponse, zCommitFiscalQuotaConsolidationResponse, zCompleteInvitationResponse, zConfirmEmailVerificationResponse, zCreateBankAccountResponse, zCreateBeneficiaryResponse, zCreateCompanyInvestorResponse, zCreateFiscalQuotaResponse, zCreateIndividualInvestorResponse, zCreateInvestmentResponse, zCreateInvestorLegalRepresentativeResponse, zCreateInvitationResponse, zCreateLegalRepresentativeResponse, zCreateOrganizationResponse, zCreateProjectForBeneficiaryResponse, zCreateProjectPosterResponse, zCreateProjectsBulkForBeneficiaryResponse, zCreateProposalResponse, zCreateTemplateResponse, zCreateUploadSessionResponse2, zCreateUserResponse, zDeactivateInvestorResponse, zDeclineProposalResponse, zDeleteAllNotificationsResponse, zDeleteBankAccountResponse, zDeleteBeneficiaryDocumentResponse, zDeleteBeneficiaryResponse, zDeleteClassificationResponse, zDeleteFiscalQuotaResponse, zDeleteInvestmentDocumentResponse, zDeleteInvestmentResponse, zDeleteInvestorDocumentResponse, zDeleteInvestorLegalRepresentativeResponse, zDeleteInvestorResponse, zDeleteLegalRepresentativeResponse, zDeleteNotificationResponse, zDeleteOrganizationDocumentResponse, zDeleteProjectDocumentResponse, zDeleteProjectPosterResponse, zDeleteProjectResponse, zDeleteTemplateResponse, zDownloadBeneficiaryDocumentResponse, zDownloadInvestmentDocumentResponse, zDownloadInvestorDocumentResponse, zDownloadMyInvestmentDocumentResponse, zDownloadOrganizationDocumentResponse, zDownloadProjectDocumentResponse, zDuplicateTemplateResponse, zExtendReservationResponse2, zGetBeneficiariesResponse, zGetBeneficiaryDetailsResponse, zGetBeneficiaryDocumentResponse, zGetBeneficiaryMetricsResponse, zGetBeneficiaryProjectsResponse, zGetCatalogResponse, zGetClassificationFileResponse, zGetClassificationLocksResponse, zGetClassificationPipelineStatusResponse, zGetClassificationResponse, zGetClassificationStatsResponse, zGetClassificationSummaryResponse, zGetCompanyInvestorResponse, zGetContractDetailsResponse, zGetContractDocumentResponse, zGetContractStatsResponse, zGetCurrentOrganizationResponse, zGetDashboardMetricsResponse, zGetDashboardStatsResponse, zGetDocumentSigningUrlResponse, zGetFiscalYearSummaryResponse, zGetIndividualInvestorResponse, zGetInvestmentDocumentResponse, zGetInvestmentMetricsResponse, zGetInvestmentResponse, zGetInvestorDocumentResponse, zGetInvestorMetricsResponse, zGetInvestorMusicDeductionSummaryResponse, zGetInvitationsResponse, zGetMembersResponse, zGetMeResponse, zGetMyDashboardResponse, zGetMyDocumentsPortfolioResponse, zGetMyInvestmentResponse, zGetMyInvitationsResponse, zGetMyMembershipsResponse, zGetMyPendingActionsResponse, zGetMyProfileResponse, zGetNotificationResponse, zGetNotificationsResponse, zGetNotificationStatsResponse, zGetOrganizationByUuidResponse, zGetOrganizationDocumentResponse, zGetOrganizationUsageResponse, zGetOrgEntitlementsResponse, zGetProjectDocumentResponse, zGetProjectPosterResponse, zGetProjectResponse, zGetProjectsResponse, zGetProposalResponse, zGetSuppliersAnalyticsResponse, zGetTaxBreakdownResponse, zGetTemplateCompatibilityResponse, zGetTemplateImagePreviewResponse, zGetTemplateResponse, zGetUploadSessionStatusResponse, zGetUserByUuidResponse, zGetUserMembershipsResponse, zGetWorkforceAnalyticsResponse, zGrantEntitlementResponse, zHandleDocusealWebhookResponse, zHandleDocusignWebhookResponse, zInviteInvestorToHubResponse, zListAllOrganizationsResponse, zListBankAccountsResponse, zListBeneficiaryDocumentsByFiscalQuotaResponse, zListBeneficiaryDocumentsResponse, zListClassificationsResponse, zListContractsResponse, zListEntitlementsResponse, zListFiscalQuotasResponse, zListInvestmentDocumentsResponse, zListInvestmentsResponse, zListInvestorDocumentsResponse, zListInvestorLegalRepresentativesResponse, zListInvestorsResponse, zListInvitationsResponse, zListLegalRepresentativesResponse, zListMembersResponse, zListMyInvestmentDocumentsResponse, zListMyInvestmentsResponse, zListMyProfilesResponse, zListOrganizationDocumentsResponse, zListProjectDocumentsResponse, zListProposalsResponse, zListRuleIdsResponse, zListTemplatesResponse, zListUsersResponse, zMarkAllAsReadResponse, zMarkAsReadResponse, zMarkAsUnreadResponse, zPreviewBeneficiariesExportResponse, zPreviewClassificationsExportResponse, zPreviewFiscalQuotaConsolidationResponse, zPreviewInvestmentsExportResponse, zPreviewInvestorsExportResponse, zQueryAgentResponse, zReclassifyClassificationResponse, zRemoveMembershipResponse, zResendDocumentResponse2, zResendInvitationResponse, zResetEntitlementQuotaResponse, zResetPasswordResponse, zResolveDuplicateResponse2, zRetryContractDispatchResponse2, zReviewBeneficiaryDocumentResponse, zReviewClassificationResponse, zReviewInvestmentDocumentResponse, zReviewInvestorDocumentResponse, zReviewOrganizationDocumentResponse, zReviewProjectDocumentResponse, zRevokeInvitationResponse, zSendCommunicationContractResponse2, zSendFinancingContractResponse2, zSendForgotPasswordEmailResponse, zSendReservationContractResponse2, zSendResetPasswordEmailResponse, zSendVerifyEmailResponse, zSetDefaultMembershipResponse, zSetPrimaryBankAccountResponse, zSetPrimaryInvestorLegalRepresentativeResponse, zSetPrimaryLegalRepresentativeResponse, zSignUploadBatchResponse2, zSubmitFeedbackResponse, zSwitchOrganizationResponse, zToggleUserStatusResponse, zUpdateBankAccountResponse, zUpdateBeneficiaryDocumentResponse, zUpdateBeneficiaryResponse, zUpdateClassificationResponse, zUpdateCompanyInvestorResponse, zUpdateEntitlementResponse, zUpdateFiscalQuotaResponse, zUpdateIndividualInvestorResponse, zUpdateInvestmentDocumentResponse, zUpdateInvestmentResponse, zUpdateInvestorDocumentResponse, zUpdateInvestorLegalRepresentativeResponse, zUpdateLegalRepresentativeResponse, zUpdateMembershipResponse, zUpdateMeResponse, zUpdateMyProfileResponse, zUpdateOrganizationDocumentResponse, zUpdateOrganizationResponse, zUpdateProjectDocumentResponse, zUpdateProjectResponse, zUpdateTemplateResponse, zUploadBeneficiaryDocumentResponse, zUploadInvestmentDocumentResponse, zUploadInvestorDocumentResponse, zUploadOrganizationDocumentResponse, zUploadPaymentReceiptResponse, zUploadProjectDocumentResponse, zUploadTemplateImageResponse, zVerifyInvitationResponse, zVoidContractResponse2 } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Health Check
 *
 * Health check with DB connectivity verification.
 */
export const healthCheck = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckData, ThrowOnError>): RequestResult<HealthCheckResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthCheckResponses, unknown, ThrowOnError>({ url: '/health', ...options });

/**
 * Ping
 *
 * Simple ping endpoint to test CORS without database dependency.
 */
export const ping = <ThrowOnError extends boolean = false>(options?: Options<PingData, ThrowOnError>): RequestResult<PingResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PingResponses, unknown, ThrowOnError>({ url: '/health/ping', ...options });

/**
 * Auth Login User
 *
 * Login user with email and password.
 */
export const authLoginUser = <ThrowOnError extends boolean = false>(options: Options<AuthLoginUserData, ThrowOnError>): RequestResult<AuthLoginUserResponses, AuthLoginUserErrors, ThrowOnError> => (options.client ?? client).post<AuthLoginUserResponses, AuthLoginUserErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthLoginUserResponse.parseAsync(data),
    url: '/api/v1/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Auth Refresh Token
 *
 * Refresh access token using refresh token.
 */
export const authRefreshToken = <ThrowOnError extends boolean = false>(options: Options<AuthRefreshTokenData, ThrowOnError>): RequestResult<AuthRefreshTokenResponses, AuthRefreshTokenErrors, ThrowOnError> => (options.client ?? client).post<AuthRefreshTokenResponses, AuthRefreshTokenErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthRefreshTokenResponse.parseAsync(data),
    url: '/api/v1/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Auth Logout
 *
 * Logout user and revoke refresh token.
 */
export const authLogout = <ThrowOnError extends boolean = false>(options: Options<AuthLogoutData, ThrowOnError>): RequestResult<AuthLogoutResponses, AuthLogoutErrors, ThrowOnError> => (options.client ?? client).post<AuthLogoutResponses, AuthLogoutErrors, ThrowOnError>({
    responseValidator: async (data) => await zAuthLogoutResponse.parseAsync(data),
    url: '/api/v1/auth/logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Verify Email
 *
 * Send email verification link to user.
 */
export const sendVerifyEmail = <ThrowOnError extends boolean = false>(options?: Options<SendVerifyEmailData, ThrowOnError>): RequestResult<SendVerifyEmailResponses, SendVerifyEmailErrors, ThrowOnError> => (options?.client ?? client).post<SendVerifyEmailResponses, SendVerifyEmailErrors, ThrowOnError>({
    responseValidator: async (data) => await zSendVerifyEmailResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/verify-email',
    ...options
});

/**
 * Send Forgot Password Email
 *
 * Send password reset email to user.
 */
export const sendForgotPasswordEmail = <ThrowOnError extends boolean = false>(options: Options<SendForgotPasswordEmailData, ThrowOnError>): RequestResult<SendForgotPasswordEmailResponses, SendForgotPasswordEmailErrors, ThrowOnError> => (options.client ?? client).post<SendForgotPasswordEmailResponses, SendForgotPasswordEmailErrors, ThrowOnError>({
    responseValidator: async (data) => await zSendForgotPasswordEmailResponse.parseAsync(data),
    url: '/api/v1/auth/forgot-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset Password
 *
 * Reset user password.
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>): RequestResult<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError> => (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    responseValidator: async (data) => await zResetPasswordResponse.parseAsync(data),
    url: '/api/v1/auth/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Password
 *
 * Change user password (requires current password).
 */
export const changePassword = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError> => (options.client ?? client).post<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    responseValidator: async (data) => await zChangePasswordResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Switch Organization
 *
 * Switch user's active organization and generate new tokens.
 */
export const switchOrganization = <ThrowOnError extends boolean = false>(options: Options<SwitchOrganizationData, ThrowOnError>): RequestResult<SwitchOrganizationResponses, SwitchOrganizationErrors, ThrowOnError> => (options.client ?? client).post<SwitchOrganizationResponses, SwitchOrganizationErrors, ThrowOnError>({
    responseValidator: async (data) => await zSwitchOrganizationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/switch-organization',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm Email Verification
 *
 * Confirm email verification using token from email link.
 */
export const confirmEmailVerification = <ThrowOnError extends boolean = false>(options: Options<ConfirmEmailVerificationData, ThrowOnError>): RequestResult<ConfirmEmailVerificationResponses, ConfirmEmailVerificationErrors, ThrowOnError> => (options.client ?? client).post<ConfirmEmailVerificationResponses, ConfirmEmailVerificationErrors, ThrowOnError>({
    responseValidator: async (data) => await zConfirmEmailVerificationResponse.parseAsync(data),
    url: '/api/v1/auth/confirm-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create User
 *
 * Create a new user with email and password.
 */
export const createUser = <ThrowOnError extends boolean = false>(options: Options<CreateUserData, ThrowOnError>): RequestResult<CreateUserResponses, CreateUserErrors, ThrowOnError> => (options.client ?? client).post<CreateUserResponses, CreateUserErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateUserResponse.parseAsync(data),
    url: '/api/v1/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Me
 *
 * Retrieve the current user.
 */
export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError> => (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetMeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me',
    ...options
});

/**
 * Update Me
 *
 * Update the current user's profile and preferences.
 */
export const updateMe = <ThrowOnError extends boolean = false>(options: Options<UpdateMeData, ThrowOnError>): RequestResult<UpdateMeResponses, UpdateMeErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMeResponses, UpdateMeErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateMeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get My Memberships
 *
 * Get memberships where the current user is a member.
 * Returns memberships with the user's role and organization details.
 */
export const getMyMemberships = <ThrowOnError extends boolean = false>(options?: Options<GetMyMembershipsData, ThrowOnError>): RequestResult<GetMyMembershipsResponses, GetMyMembershipsErrors, ThrowOnError> => (options?.client ?? client).get<GetMyMembershipsResponses, GetMyMembershipsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetMyMembershipsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/memberships',
    ...options
});

/**
 * Get My Invitations
 *
 * Get invitations where the current user is a recipient.
 */
export const getMyInvitations = <ThrowOnError extends boolean = false>(options?: Options<GetMyInvitationsData, ThrowOnError>): RequestResult<GetMyInvitationsResponses, GetMyInvitationsErrors, ThrowOnError> => (options?.client ?? client).get<GetMyInvitationsResponses, GetMyInvitationsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetMyInvitationsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/invitations',
    ...options
});

/**
 * Set Default Membership
 *
 * Set the current user's default membership.
 */
export const setDefaultMembership = <ThrowOnError extends boolean = false>(options: Options<SetDefaultMembershipData, ThrowOnError>): RequestResult<SetDefaultMembershipResponses, SetDefaultMembershipErrors, ThrowOnError> => (options.client ?? client).post<SetDefaultMembershipResponses, SetDefaultMembershipErrors, ThrowOnError>({
    responseValidator: async (data) => await zSetDefaultMembershipResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/actions/set-default-membership',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Handle Docusign Webhook
 *
 * Handle DocuSign Connect webhook events.
 *
 * Processes envelope status changes and signature completions.
 * Headers:
 * - X-DocuSign-Signature-1: HMAC signature for verification
 * - X-Authorization-Digest: Hash algorithm used (SHA256)
 */
export const handleDocusignWebhook = <ThrowOnError extends boolean = false>(options?: Options<HandleDocusignWebhookData, ThrowOnError>): RequestResult<HandleDocusignWebhookResponses, HandleDocusignWebhookErrors, ThrowOnError> => (options?.client ?? client).post<HandleDocusignWebhookResponses, HandleDocusignWebhookErrors, ThrowOnError>({
    responseValidator: async (data) => await zHandleDocusignWebhookResponse.parseAsync(data),
    url: '/api/v1/webhooks/docusign',
    ...options
});

/**
 * Handle Docuseal Webhook
 *
 * Handle DocuSeal webhook events.
 *
 * Validates HMAC signature, parses the event into a provider-agnostic
 * SignatureEvent, and delegates to the business-logic handler. In-app
 * notifications and outbox email events commit atomically with the
 * signature-state change.
 */
export const handleDocusealWebhook = <ThrowOnError extends boolean = false>(options?: Options<HandleDocusealWebhookData, ThrowOnError>): RequestResult<HandleDocusealWebhookResponses, HandleDocusealWebhookErrors, ThrowOnError> => (options?.client ?? client).post<HandleDocusealWebhookResponses, HandleDocusealWebhookErrors, ThrowOnError>({
    responseValidator: async (data) => await zHandleDocusealWebhookResponse.parseAsync(data),
    url: '/api/v1/webhooks/docuseal',
    ...options
});

/**
 * Delete All Notifications
 *
 * Delete all notifications for the current user
 */
export const deleteAllNotifications = <ThrowOnError extends boolean = false>(options?: Options<DeleteAllNotificationsData, ThrowOnError>): RequestResult<DeleteAllNotificationsResponses, DeleteAllNotificationsErrors, ThrowOnError> => (options?.client ?? client).delete<DeleteAllNotificationsResponses, DeleteAllNotificationsErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteAllNotificationsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications',
    ...options
});

/**
 * Get Notifications
 *
 * Get notifications for the current user with filtering, sorting, and pagination.
 */
export const getNotifications = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationsData, ThrowOnError>): RequestResult<GetNotificationsResponses, GetNotificationsErrors, ThrowOnError> => (options?.client ?? client).get<GetNotificationsResponses, GetNotificationsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetNotificationsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications',
    ...options
});

/**
 * Get Notification Stats
 *
 * Get notification statistics for the current user
 */
export const getNotificationStats = <ThrowOnError extends boolean = false>(options?: Options<GetNotificationStatsData, ThrowOnError>): RequestResult<GetNotificationStatsResponses, GetNotificationStatsErrors, ThrowOnError> => (options?.client ?? client).get<GetNotificationStatsResponses, GetNotificationStatsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetNotificationStatsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications/stats',
    ...options
});

/**
 * Delete Notification
 *
 * Delete a notification
 */
export const deleteNotification = <ThrowOnError extends boolean = false>(options: Options<DeleteNotificationData, ThrowOnError>): RequestResult<DeleteNotificationResponses, DeleteNotificationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteNotificationResponses, DeleteNotificationErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteNotificationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications/{notification_uuid}',
    ...options
});

/**
 * Get Notification
 *
 * Get a specific notification
 */
export const getNotification = <ThrowOnError extends boolean = false>(options: Options<GetNotificationData, ThrowOnError>): RequestResult<GetNotificationResponses, GetNotificationErrors, ThrowOnError> => (options.client ?? client).get<GetNotificationResponses, GetNotificationErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetNotificationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications/{notification_uuid}',
    ...options
});

/**
 * Mark As Read
 *
 * Mark a notification as read
 */
export const markAsRead = <ThrowOnError extends boolean = false>(options: Options<MarkAsReadData, ThrowOnError>): RequestResult<MarkAsReadResponses, MarkAsReadErrors, ThrowOnError> => (options.client ?? client).post<MarkAsReadResponses, MarkAsReadErrors, ThrowOnError>({
    responseValidator: async (data) => await zMarkAsReadResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications/{notification_uuid}/actions/mark-as-read',
    ...options
});

/**
 * Mark As Unread
 *
 * Mark a notification as unread
 */
export const markAsUnread = <ThrowOnError extends boolean = false>(options: Options<MarkAsUnreadData, ThrowOnError>): RequestResult<MarkAsUnreadResponses, MarkAsUnreadErrors, ThrowOnError> => (options.client ?? client).post<MarkAsUnreadResponses, MarkAsUnreadErrors, ThrowOnError>({
    responseValidator: async (data) => await zMarkAsUnreadResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications/{notification_uuid}/actions/mark-as-unread',
    ...options
});

/**
 * Mark All As Read
 *
 * Mark all notifications as read for the current user
 */
export const markAllAsRead = <ThrowOnError extends boolean = false>(options?: Options<MarkAllAsReadData, ThrowOnError>): RequestResult<MarkAllAsReadResponses, MarkAllAsReadErrors, ThrowOnError> => (options?.client ?? client).post<MarkAllAsReadResponses, MarkAllAsReadErrors, ThrowOnError>({
    responseValidator: async (data) => await zMarkAllAsReadResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/notifications/actions/mark-all-read',
    ...options
});

/**
 * Get Current Organization
 *
 * Get the current organization from JWT context.
 */
export const getCurrentOrganization = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentOrganizationData, ThrowOnError>): RequestResult<GetCurrentOrganizationResponses, GetCurrentOrganizationErrors, ThrowOnError> => (options?.client ?? client).get<GetCurrentOrganizationResponses, GetCurrentOrganizationErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetCurrentOrganizationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations',
    ...options
});

/**
 * Update Organization
 *
 * Update the current organization. Only owners can perform this action.
 */
export const updateOrganization = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationData, ThrowOnError>): RequestResult<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateOrganizationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Organization Documents
 *
 * List documents for the current organization with pagination. Defaults to ACTIVE only.
 */
export const listOrganizationDocuments = <ThrowOnError extends boolean = false>(options?: Options<ListOrganizationDocumentsData, ThrowOnError>): RequestResult<ListOrganizationDocumentsResponses, ListOrganizationDocumentsErrors, ThrowOnError> => (options?.client ?? client).get<ListOrganizationDocumentsResponses, ListOrganizationDocumentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListOrganizationDocumentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/documents',
    ...options
});

/**
 * Upload Organization Document
 *
 * Upload a document for the organization.
 */
export const uploadOrganizationDocument = <ThrowOnError extends boolean = false>(options: Options<UploadOrganizationDocumentData, ThrowOnError>): RequestResult<UploadOrganizationDocumentResponses, UploadOrganizationDocumentErrors, ThrowOnError> => (options.client ?? client).post<UploadOrganizationDocumentResponses, UploadOrganizationDocumentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zUploadOrganizationDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/documents',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Organization Document
 *
 * Soft-delete an organization document (archive).
 */
export const deleteOrganizationDocument = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganizationDocumentData, ThrowOnError>): RequestResult<DeleteOrganizationDocumentResponses, DeleteOrganizationDocumentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrganizationDocumentResponses, DeleteOrganizationDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteOrganizationDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/documents/{document_uuid}',
    ...options
});

/**
 * Get Organization Document
 *
 * Get specific organization document details with review status.
 */
export const getOrganizationDocument = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationDocumentData, ThrowOnError>): RequestResult<GetOrganizationDocumentResponses, GetOrganizationDocumentErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationDocumentResponses, GetOrganizationDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetOrganizationDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/documents/{document_uuid}',
    ...options
});

/**
 * Update Organization Document
 *
 * Update organization document metadata (title, description).
 */
export const updateOrganizationDocument = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationDocumentData, ThrowOnError>): RequestResult<UpdateOrganizationDocumentResponses, UpdateOrganizationDocumentErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationDocumentResponses, UpdateOrganizationDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateOrganizationDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/documents/{document_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Organization Document
 *
 * Get signed URL for downloading an organization document.
 */
export const downloadOrganizationDocument = <ThrowOnError extends boolean = false>(options: Options<DownloadOrganizationDocumentData, ThrowOnError>): RequestResult<DownloadOrganizationDocumentResponses, DownloadOrganizationDocumentErrors, ThrowOnError> => (options.client ?? client).get<DownloadOrganizationDocumentResponses, DownloadOrganizationDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zDownloadOrganizationDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/documents/{document_uuid}/download',
    ...options
});

/**
 * Review Organization Document
 *
 * Approve or reject an organization document review.
 */
export const reviewOrganizationDocument = <ThrowOnError extends boolean = false>(options: Options<ReviewOrganizationDocumentData, ThrowOnError>): RequestResult<ReviewOrganizationDocumentResponses, ReviewOrganizationDocumentErrors, ThrowOnError> => (options.client ?? client).post<ReviewOrganizationDocumentResponses, ReviewOrganizationDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zReviewOrganizationDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/organizations/documents/{document_uuid}/actions/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Invitations
 *
 * Get all invitations (public endpoint).
 */
export const getInvitations = <ThrowOnError extends boolean = false>(options?: Options<GetInvitationsData, ThrowOnError>): RequestResult<GetInvitationsResponses, GetInvitationsErrors, ThrowOnError> => (options?.client ?? client).get<GetInvitationsResponses, GetInvitationsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetInvitationsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/invitations',
    ...options
});

/**
 * Create Invitation
 *
 * Create a new invitation.
 * Only organization owners can create invitations.
 */
export const createInvitation = <ThrowOnError extends boolean = false>(options: Options<CreateInvitationData, ThrowOnError>): RequestResult<CreateInvitationResponses, CreateInvitationErrors, ThrowOnError> => (options.client ?? client).post<CreateInvitationResponses, CreateInvitationErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateInvitationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify Invitation
 *
 * Verify invitation token (public endpoint).
 * Called by frontend when user clicks email link.
 * Returns invitation details if token is valid.
 */
export const verifyInvitation = <ThrowOnError extends boolean = false>(options: Options<VerifyInvitationData, ThrowOnError>): RequestResult<VerifyInvitationResponses, VerifyInvitationErrors, ThrowOnError> => (options.client ?? client).get<VerifyInvitationResponses, VerifyInvitationErrors, ThrowOnError>({
    responseValidator: async (data) => await zVerifyInvitationResponse.parseAsync(data),
    url: '/api/v1/invitations/by-token',
    ...options
});

/**
 * Resend Invitation
 *
 * Resend invitation email.
 * Only organization owners can resend invitations from their org.
 */
export const resendInvitation = <ThrowOnError extends boolean = false>(options: Options<ResendInvitationData, ThrowOnError>): RequestResult<ResendInvitationResponses, ResendInvitationErrors, ThrowOnError> => (options.client ?? client).post<ResendInvitationResponses, ResendInvitationErrors, ThrowOnError>({
    responseValidator: async (data) => await zResendInvitationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/invitations/{invitation_uuid}/actions/resend',
    ...options
});

/**
 * Complete Invitation
 *
 * Complete invitation (public endpoint).
 * Handles user creation, organization setup, and membership based on invitation type.
 */
export const completeInvitation = <ThrowOnError extends boolean = false>(options: Options<CompleteInvitationData, ThrowOnError>): RequestResult<CompleteInvitationResponses, CompleteInvitationErrors, ThrowOnError> => (options.client ?? client).post<CompleteInvitationResponses, CompleteInvitationErrors, ThrowOnError>({
    responseValidator: async (data) => await zCompleteInvitationResponse.parseAsync(data),
    url: '/api/v1/invitations/{invitation_uuid}/actions/complete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke Invitation
 *
 * Revoke invitation (authenticated endpoint).
 * Only organization owners can revoke invitations from their org.
 */
export const revokeInvitation = <ThrowOnError extends boolean = false>(options: Options<RevokeInvitationData, ThrowOnError>): RequestResult<RevokeInvitationResponses, RevokeInvitationErrors, ThrowOnError> => (options.client ?? client).delete<RevokeInvitationResponses, RevokeInvitationErrors, ThrowOnError>({
    responseValidator: async (data) => await zRevokeInvitationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/invitations/{invitation_uuid}',
    ...options
});

/**
 * Get Members
 *
 * Get all members of the current organization.
 */
export const getMembers = <ThrowOnError extends boolean = false>(options?: Options<GetMembersData, ThrowOnError>): RequestResult<GetMembersResponses, GetMembersErrors, ThrowOnError> => (options?.client ?? client).get<GetMembersResponses, GetMembersErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetMembersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/memberships',
    ...options
});

/**
 * Remove Membership
 *
 * Remove a membership (remove user from organization).
 * Only organization owners can remove memberships.
 */
export const removeMembership = <ThrowOnError extends boolean = false>(options: Options<RemoveMembershipData, ThrowOnError>): RequestResult<RemoveMembershipResponses, RemoveMembershipErrors, ThrowOnError> => (options.client ?? client).delete<RemoveMembershipResponses, RemoveMembershipErrors, ThrowOnError>({
    responseValidator: async (data) => await zRemoveMembershipResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/memberships/{membership_uuid}',
    ...options
});

/**
 * Update Membership
 *
 * Update a membership.
 * Only organization owners can update memberships.
 */
export const updateMembership = <ThrowOnError extends boolean = false>(options: Options<UpdateMembershipData, ThrowOnError>): RequestResult<UpdateMembershipResponses, UpdateMembershipErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMembershipResponses, UpdateMembershipErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateMembershipResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/memberships/{membership_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Beneficiaries
 *
 * Get all beneficiaries for the current organization with filtering and statistics.
 *
 * Supports filtering by status, sector, and search query.
 * Returns paginated results with project counts and current year quota.
 */
export const getBeneficiaries = <ThrowOnError extends boolean = false>(options?: Options<GetBeneficiariesData, ThrowOnError>): RequestResult<GetBeneficiariesResponses, GetBeneficiariesErrors, ThrowOnError> => (options?.client ?? client).get<GetBeneficiariesResponses, GetBeneficiariesErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetBeneficiariesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries',
    ...options
});

/**
 * Create Beneficiary
 *
 * Create a beneficiary for the current organization.
 */
export const createBeneficiary = <ThrowOnError extends boolean = false>(options: Options<CreateBeneficiaryData, ThrowOnError>): RequestResult<CreateBeneficiaryResponses, CreateBeneficiaryErrors, ThrowOnError> => (options.client ?? client).post<CreateBeneficiaryResponses, CreateBeneficiaryErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateBeneficiaryResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Beneficiary Metrics
 *
 * Get aggregated metrics for beneficiaries matching the filters.
 *
 * Returns summary KPIs (total count, by status, quota metrics) that update
 * when filters are applied. Unlike the list endpoint, this aggregates across
 * the full filtered dataset without pagination.
 *
 * Use this endpoint in conjunction with the list endpoint to display
 * filtered KPI cards above the beneficiaries table.
 */
export const getBeneficiaryMetrics = <ThrowOnError extends boolean = false>(options?: Options<GetBeneficiaryMetricsData, ThrowOnError>): RequestResult<GetBeneficiaryMetricsResponses, GetBeneficiaryMetricsErrors, ThrowOnError> => (options?.client ?? client).get<GetBeneficiaryMetricsResponses, GetBeneficiaryMetricsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetBeneficiaryMetricsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/metrics',
    ...options
});

/**
 * Preview Beneficiaries Export
 *
 * Summary returned to the export modal before the user confirms.
 */
export const previewBeneficiariesExport = <ThrowOnError extends boolean = false>(options?: Options<PreviewBeneficiariesExportData, ThrowOnError>): RequestResult<PreviewBeneficiariesExportResponses, PreviewBeneficiariesExportErrors, ThrowOnError> => (options?.client ?? client).get<PreviewBeneficiariesExportResponses, PreviewBeneficiariesExportErrors, ThrowOnError>({
    responseValidator: async (data) => await zPreviewBeneficiariesExportResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/export/preview',
    ...options
});

/**
 * Export Beneficiaries
 *
 * Export all beneficiaries matching the filters in the requested format.
 */
export const exportBeneficiaries = <ThrowOnError extends boolean = false>(options?: Options<ExportBeneficiariesData, ThrowOnError>): RequestResult<ExportBeneficiariesResponses, ExportBeneficiariesErrors, ThrowOnError> => (options?.client ?? client).get<ExportBeneficiariesResponses, ExportBeneficiariesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/export',
    ...options
});

/**
 * Delete Beneficiary
 *
 * Delete a beneficiary.
 * Only organization owners can delete beneficiaries.
 */
export const deleteBeneficiary = <ThrowOnError extends boolean = false>(options: Options<DeleteBeneficiaryData, ThrowOnError>): RequestResult<DeleteBeneficiaryResponses, DeleteBeneficiaryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBeneficiaryResponses, DeleteBeneficiaryErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteBeneficiaryResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}',
    ...options
});

/**
 * Get Beneficiary Details
 *
 * Get beneficiary details with all nested entities.
 */
export const getBeneficiaryDetails = <ThrowOnError extends boolean = false>(options: Options<GetBeneficiaryDetailsData, ThrowOnError>): RequestResult<GetBeneficiaryDetailsResponses, GetBeneficiaryDetailsErrors, ThrowOnError> => (options.client ?? client).get<GetBeneficiaryDetailsResponses, GetBeneficiaryDetailsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetBeneficiaryDetailsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}',
    ...options
});

/**
 * Update Beneficiary
 *
 * Update a beneficiary.
 */
export const updateBeneficiary = <ThrowOnError extends boolean = false>(options: Options<UpdateBeneficiaryData, ThrowOnError>): RequestResult<UpdateBeneficiaryResponses, UpdateBeneficiaryErrors, ThrowOnError> => (options.client ?? client).patch<UpdateBeneficiaryResponses, UpdateBeneficiaryErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateBeneficiaryResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Legal Representatives
 *
 * Get all legal representatives for a beneficiary.
 */
export const listLegalRepresentatives = <ThrowOnError extends boolean = false>(options: Options<ListLegalRepresentativesData, ThrowOnError>): RequestResult<ListLegalRepresentativesResponses, ListLegalRepresentativesErrors, ThrowOnError> => (options.client ?? client).get<ListLegalRepresentativesResponses, ListLegalRepresentativesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListLegalRepresentativesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/legal-representatives',
    ...options
});

/**
 * Create Legal Representative
 *
 * Create a legal representative for a beneficiary.
 */
export const createLegalRepresentative = <ThrowOnError extends boolean = false>(options: Options<CreateLegalRepresentativeData, ThrowOnError>): RequestResult<CreateLegalRepresentativeResponses, CreateLegalRepresentativeErrors, ThrowOnError> => (options.client ?? client).post<CreateLegalRepresentativeResponses, CreateLegalRepresentativeErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateLegalRepresentativeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/legal-representatives',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Legal Representative
 *
 * Delete a legal representative.
 */
export const deleteLegalRepresentative = <ThrowOnError extends boolean = false>(options: Options<DeleteLegalRepresentativeData, ThrowOnError>): RequestResult<DeleteLegalRepresentativeResponses, DeleteLegalRepresentativeErrors, ThrowOnError> => (options.client ?? client).delete<DeleteLegalRepresentativeResponses, DeleteLegalRepresentativeErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteLegalRepresentativeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/legal-representatives/{representative_uuid}',
    ...options
});

/**
 * Update Legal Representative
 *
 * Update a legal representative.
 */
export const updateLegalRepresentative = <ThrowOnError extends boolean = false>(options: Options<UpdateLegalRepresentativeData, ThrowOnError>): RequestResult<UpdateLegalRepresentativeResponses, UpdateLegalRepresentativeErrors, ThrowOnError> => (options.client ?? client).patch<UpdateLegalRepresentativeResponses, UpdateLegalRepresentativeErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateLegalRepresentativeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/legal-representatives/{representative_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Primary Legal Representative
 *
 * Set a legal representative as primary.
 */
export const setPrimaryLegalRepresentative = <ThrowOnError extends boolean = false>(options: Options<SetPrimaryLegalRepresentativeData, ThrowOnError>): RequestResult<SetPrimaryLegalRepresentativeResponses, SetPrimaryLegalRepresentativeErrors, ThrowOnError> => (options.client ?? client).post<SetPrimaryLegalRepresentativeResponses, SetPrimaryLegalRepresentativeErrors, ThrowOnError>({
    responseValidator: async (data) => await zSetPrimaryLegalRepresentativeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/legal-representatives/{representative_uuid}/actions/set-primary',
    ...options
});

/**
 * List Bank Accounts
 *
 * Get all bank accounts for a beneficiary.
 */
export const listBankAccounts = <ThrowOnError extends boolean = false>(options: Options<ListBankAccountsData, ThrowOnError>): RequestResult<ListBankAccountsResponses, ListBankAccountsErrors, ThrowOnError> => (options.client ?? client).get<ListBankAccountsResponses, ListBankAccountsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListBankAccountsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/bank-accounts',
    ...options
});

/**
 * Create Bank Account
 *
 * Create a bank account for a beneficiary.
 */
export const createBankAccount = <ThrowOnError extends boolean = false>(options: Options<CreateBankAccountData, ThrowOnError>): RequestResult<CreateBankAccountResponses, CreateBankAccountErrors, ThrowOnError> => (options.client ?? client).post<CreateBankAccountResponses, CreateBankAccountErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateBankAccountResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/bank-accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Bank Account
 *
 * Delete a bank account.
 * Only organization owners can delete bank accounts.
 */
export const deleteBankAccount = <ThrowOnError extends boolean = false>(options: Options<DeleteBankAccountData, ThrowOnError>): RequestResult<DeleteBankAccountResponses, DeleteBankAccountErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBankAccountResponses, DeleteBankAccountErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteBankAccountResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/bank-accounts/{bank_account_uuid}',
    ...options
});

/**
 * Update Bank Account
 *
 * Update a bank account.
 */
export const updateBankAccount = <ThrowOnError extends boolean = false>(options: Options<UpdateBankAccountData, ThrowOnError>): RequestResult<UpdateBankAccountResponses, UpdateBankAccountErrors, ThrowOnError> => (options.client ?? client).patch<UpdateBankAccountResponses, UpdateBankAccountErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateBankAccountResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/bank-accounts/{bank_account_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Primary Bank Account
 *
 * Set a bank account as primary.
 */
export const setPrimaryBankAccount = <ThrowOnError extends boolean = false>(options: Options<SetPrimaryBankAccountData, ThrowOnError>): RequestResult<SetPrimaryBankAccountResponses, SetPrimaryBankAccountErrors, ThrowOnError> => (options.client ?? client).post<SetPrimaryBankAccountResponses, SetPrimaryBankAccountErrors, ThrowOnError>({
    responseValidator: async (data) => await zSetPrimaryBankAccountResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/bank-accounts/{bank_account_uuid}/actions/set-primary',
    ...options
});

/**
 * List Fiscal Quotas
 *
 * List all fiscal quotas for a beneficiary.
 */
export const listFiscalQuotas = <ThrowOnError extends boolean = false>(options: Options<ListFiscalQuotasData, ThrowOnError>): RequestResult<ListFiscalQuotasResponses, ListFiscalQuotasErrors, ThrowOnError> => (options.client ?? client).get<ListFiscalQuotasResponses, ListFiscalQuotasErrors, ThrowOnError>({
    responseValidator: async (data) => await zListFiscalQuotasResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/fiscal-quotas',
    ...options
});

/**
 * Create Fiscal Quota
 *
 * Create a new fiscal quota for a beneficiary.
 */
export const createFiscalQuota = <ThrowOnError extends boolean = false>(options: Options<CreateFiscalQuotaData, ThrowOnError>): RequestResult<CreateFiscalQuotaResponses, CreateFiscalQuotaErrors, ThrowOnError> => (options.client ?? client).post<CreateFiscalQuotaResponses, CreateFiscalQuotaErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateFiscalQuotaResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/fiscal-quotas',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Fiscal Quota
 *
 * Delete a beneficiary's fiscal quota.
 */
export const deleteFiscalQuota = <ThrowOnError extends boolean = false>(options: Options<DeleteFiscalQuotaData, ThrowOnError>): RequestResult<DeleteFiscalQuotaResponses, DeleteFiscalQuotaErrors, ThrowOnError> => (options.client ?? client).delete<DeleteFiscalQuotaResponses, DeleteFiscalQuotaErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteFiscalQuotaResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/fiscal-quotas/{fiscal_quota_uuid}',
    ...options
});

/**
 * Update Fiscal Quota
 *
 * Update a beneficiary's fiscal quota.
 */
export const updateFiscalQuota = <ThrowOnError extends boolean = false>(options: Options<UpdateFiscalQuotaData, ThrowOnError>): RequestResult<UpdateFiscalQuotaResponses, UpdateFiscalQuotaErrors, ThrowOnError> => (options.client ?? client).patch<UpdateFiscalQuotaResponses, UpdateFiscalQuotaErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateFiscalQuotaResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/fiscal-quotas/{fiscal_quota_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Fiscal Year Summary
 *
 * Get a fiscal-year summary for a beneficiary: aggregate metrics across all
 * quotas of that year plus the list of enriched quotas.
 *
 * Works uniformly for music (typically 1 quota/year — aggregate equals the
 * single quota's metrics) and film (N quotas/year, 1 per production).
 */
export const getFiscalYearSummary = <ThrowOnError extends boolean = false>(options: Options<GetFiscalYearSummaryData, ThrowOnError>): RequestResult<GetFiscalYearSummaryResponses, GetFiscalYearSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetFiscalYearSummaryResponses, GetFiscalYearSummaryErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetFiscalYearSummaryResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/fiscal-year-summary',
    ...options
});

/**
 * Preview Fiscal Quota Consolidation
 *
 * Compute the proposed consolidation snapshot live (no DB writes).
 *
 * Drives the sync modal — the asesor reviews the per-bucket numbers and
 * may override before committing.
 */
export const previewFiscalQuotaConsolidation = <ThrowOnError extends boolean = false>(options: Options<PreviewFiscalQuotaConsolidationData, ThrowOnError>): RequestResult<PreviewFiscalQuotaConsolidationResponses, PreviewFiscalQuotaConsolidationErrors, ThrowOnError> => (options.client ?? client).get<PreviewFiscalQuotaConsolidationResponses, PreviewFiscalQuotaConsolidationErrors, ThrowOnError>({
    responseValidator: async (data) => await zPreviewFiscalQuotaConsolidationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/fiscal-quotas/{fiscal_quota_uuid}/consolidation-preview',
    ...options
});

/**
 * Commit Fiscal Quota Consolidation
 *
 * Write the consolidation snapshot atomically.
 *
 * Re-sync semantics: replaces the previous snapshot. The
 * consolidation_source JSONB preserves the list of classifications
 * included plus any per-bucket asesor overrides for audit.
 */
export const commitFiscalQuotaConsolidation = <ThrowOnError extends boolean = false>(options: Options<CommitFiscalQuotaConsolidationData, ThrowOnError>): RequestResult<CommitFiscalQuotaConsolidationResponses, CommitFiscalQuotaConsolidationErrors, ThrowOnError> => (options.client ?? client).post<CommitFiscalQuotaConsolidationResponses, CommitFiscalQuotaConsolidationErrors, ThrowOnError>({
    responseValidator: async (data) => await zCommitFiscalQuotaConsolidationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/fiscal-quotas/{fiscal_quota_uuid}/actions/consolidate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Beneficiary Documents
 *
 * Return every document relevant to a beneficiary.
 *
 * The response partitions the matching documents into three sections:
 *
 * - ``owned``: documents whose ``entity_type=BENEFICIARY`` and ``entity_uuid``
 * matches the beneficiary (certificates, INAEM, classifier uploads, etc.).
 * - ``from_bank_accounts``: documents attached to the beneficiary's bank
 * accounts, grouped per account with bank name and IBAN last 4 digits.
 * - ``from_investments``: documents scoped to each investment where this
 * beneficiary is party of, grouped per investment with reference/state/amount.
 *
 * Filters (``document_type``, ``status``, ``fiscal_quota_uuid``, ``search``) narrow
 * the result across every section uniformly. Pagination applies to the flat
 * document set (ordered by ``uploaded_at DESC``) and the section layout is
 * rebuilt from whichever documents fit on the current page.
 *
 * Query count is constant regardless of how many investments or bank accounts
 * the beneficiary has: a single batched query on the unified ``documents`` table.
 */
export const listBeneficiaryDocuments = <ThrowOnError extends boolean = false>(options: Options<ListBeneficiaryDocumentsData, ThrowOnError>): RequestResult<ListBeneficiaryDocumentsResponses, ListBeneficiaryDocumentsErrors, ThrowOnError> => (options.client ?? client).get<ListBeneficiaryDocumentsResponses, ListBeneficiaryDocumentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListBeneficiaryDocumentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/documents',
    ...options
});

/**
 * Upload Beneficiary Document
 *
 * Upload a document for a beneficiary or bank account.
 *
 * For beneficiary-scoped uploads the caller can:
 * - link the document to a fiscal quota (``fiscal_quota_uuid``), which
 * buckets it in the corresponding section of the DocumentsTab; and
 * - opt into sharing it with the investors of that quota
 * (``share_with_investors``), which creates one ``document_access`` row
 * with ``audience=beneficiary_investors`` scoped to the linked quota.
 *
 * Both fields are ignored for ``BENEFICIARY_BANK_ACCOUNT`` uploads — bank
 * documents are always static and never quota-scoped.
 */
export const uploadBeneficiaryDocument = <ThrowOnError extends boolean = false>(options: Options<UploadBeneficiaryDocumentData, ThrowOnError>): RequestResult<UploadBeneficiaryDocumentResponses, UploadBeneficiaryDocumentErrors, ThrowOnError> => (options.client ?? client).post<UploadBeneficiaryDocumentResponses, UploadBeneficiaryDocumentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zUploadBeneficiaryDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/documents',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Beneficiary Documents By Fiscal Quota
 *
 * Return the beneficiary's own documents grouped by fiscal quota.
 *
 * Only the documents that live on the beneficiary scope itself are
 * returned (no bank-account or investment docs). The result is
 * structured as one group per distinct ``fiscal_quota_id``, plus a
 * leading ``"General"`` group (``fiscal_quota_uuid=None``) for documents
 * not linked to any quota.
 *
 * Each group carries the true ``total`` across all pages and at most
 * ``per_group_limit`` documents in ``uploaded_at DESC`` order. Loading
 * additional documents inside a single group is delegated to the flat
 * ``GET /beneficiaries/{uuid}/documents?fiscal_quota_uuid=...`` endpoint,
 * so the frontend can lazy-load on scroll.
 *
 * Implementation: one ranked SELECT with ``ROW_NUMBER() OVER (PARTITION BY
 * fiscal_quota_id ORDER BY uploaded_at DESC)`` and
 * ``COUNT(*) OVER (PARTITION BY fiscal_quota_id)``, plus the standard
 * satellite fetch for reviews and signatures.
 */
export const listBeneficiaryDocumentsByFiscalQuota = <ThrowOnError extends boolean = false>(options: Options<ListBeneficiaryDocumentsByFiscalQuotaData, ThrowOnError>): RequestResult<ListBeneficiaryDocumentsByFiscalQuotaResponses, ListBeneficiaryDocumentsByFiscalQuotaErrors, ThrowOnError> => (options.client ?? client).get<ListBeneficiaryDocumentsByFiscalQuotaResponses, ListBeneficiaryDocumentsByFiscalQuotaErrors, ThrowOnError>({
    responseValidator: async (data) => await zListBeneficiaryDocumentsByFiscalQuotaResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/documents/by-fiscal-quota',
    ...options
});

/**
 * Delete Beneficiary Document
 *
 * Soft-delete a beneficiary document (archive).
 */
export const deleteBeneficiaryDocument = <ThrowOnError extends boolean = false>(options: Options<DeleteBeneficiaryDocumentData, ThrowOnError>): RequestResult<DeleteBeneficiaryDocumentResponses, DeleteBeneficiaryDocumentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBeneficiaryDocumentResponses, DeleteBeneficiaryDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteBeneficiaryDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/documents/{document_uuid}',
    ...options
});

/**
 * Get Beneficiary Document
 *
 * Get specific beneficiary document details with review status.
 */
export const getBeneficiaryDocument = <ThrowOnError extends boolean = false>(options: Options<GetBeneficiaryDocumentData, ThrowOnError>): RequestResult<GetBeneficiaryDocumentResponses, GetBeneficiaryDocumentErrors, ThrowOnError> => (options.client ?? client).get<GetBeneficiaryDocumentResponses, GetBeneficiaryDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetBeneficiaryDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/documents/{document_uuid}',
    ...options
});

/**
 * Update Beneficiary Document
 *
 * Update beneficiary document metadata (title, description, quota, share).
 */
export const updateBeneficiaryDocument = <ThrowOnError extends boolean = false>(options: Options<UpdateBeneficiaryDocumentData, ThrowOnError>): RequestResult<UpdateBeneficiaryDocumentResponses, UpdateBeneficiaryDocumentErrors, ThrowOnError> => (options.client ?? client).patch<UpdateBeneficiaryDocumentResponses, UpdateBeneficiaryDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateBeneficiaryDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/documents/{document_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Beneficiary Document
 *
 * Get signed URL for downloading a beneficiary document.
 */
export const downloadBeneficiaryDocument = <ThrowOnError extends boolean = false>(options: Options<DownloadBeneficiaryDocumentData, ThrowOnError>): RequestResult<DownloadBeneficiaryDocumentResponses, DownloadBeneficiaryDocumentErrors, ThrowOnError> => (options.client ?? client).get<DownloadBeneficiaryDocumentResponses, DownloadBeneficiaryDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zDownloadBeneficiaryDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/documents/{document_uuid}/download',
    ...options
});

/**
 * Review Beneficiary Document
 *
 * Approve or reject a beneficiary document review.
 */
export const reviewBeneficiaryDocument = <ThrowOnError extends boolean = false>(options: Options<ReviewBeneficiaryDocumentData, ThrowOnError>): RequestResult<ReviewBeneficiaryDocumentResponses, ReviewBeneficiaryDocumentErrors, ThrowOnError> => (options.client ?? client).post<ReviewBeneficiaryDocumentResponses, ReviewBeneficiaryDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zReviewBeneficiaryDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/documents/{document_uuid}/actions/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Projects
 *
 * Get projects with filtering and pagination.
 *
 * Supports:
 * - status: Filter by project status (active, inactive)
 * - subtype: Filter by project subtype
 * - beneficiary_uuid: Filter by beneficiary
 * - search: Search in title and description
 * - sort_by: Sort by field (title, created_at, status, fiscal_year,
 * incentive, generated_deduction, fundraising_deadline)
 * - sort_direction: Sort direction (asc, desc)
 * - limit/offset: Pagination
 */
export const getProjects = <ThrowOnError extends boolean = false>(options?: Options<GetProjectsData, ThrowOnError>): RequestResult<GetProjectsResponses, GetProjectsErrors, ThrowOnError> => (options?.client ?? client).get<GetProjectsResponses, GetProjectsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetProjectsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects',
    ...options
});

/**
 * Delete Project
 *
 * Delete a project.
 */
export const deleteProject = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectData, ThrowOnError>): RequestResult<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteProjectResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{project_uuid}',
    ...options
});

/**
 * Get Project
 *
 * Get project details by UUID including investors information.
 */
export const getProject = <ThrowOnError extends boolean = false>(options: Options<GetProjectData, ThrowOnError>): RequestResult<GetProjectResponses, GetProjectErrors, ThrowOnError> => (options.client ?? client).get<GetProjectResponses, GetProjectErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetProjectResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{project_uuid}',
    ...options
});

/**
 * Update Project
 *
 * Update a project.
 */
export const updateProject = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectData, ThrowOnError>): RequestResult<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateProjectResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{project_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Beneficiary Projects
 *
 * Get all projects for a specific beneficiary.
 */
export const getBeneficiaryProjects = <ThrowOnError extends boolean = false>(options: Options<GetBeneficiaryProjectsData, ThrowOnError>): RequestResult<GetBeneficiaryProjectsResponses, GetBeneficiaryProjectsErrors, ThrowOnError> => (options.client ?? client).get<GetBeneficiaryProjectsResponses, GetBeneficiaryProjectsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetBeneficiaryProjectsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/projects',
    ...options
});

/**
 * Create Project For Beneficiary
 *
 * Create a project for a specific beneficiary.
 *
 * Resolves the ``fiscal_quota_uuid`` from the request body to a fiscal quota
 * entity and passes its numeric id to the service so the project is linked
 * to both the beneficiary and the fiscal quota it belongs to.
 */
export const createProjectForBeneficiary = <ThrowOnError extends boolean = false>(options: Options<CreateProjectForBeneficiaryData, ThrowOnError>): RequestResult<CreateProjectForBeneficiaryResponses, CreateProjectForBeneficiaryErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectForBeneficiaryResponses, CreateProjectForBeneficiaryErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateProjectForBeneficiaryResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Projects Bulk For Beneficiary
 *
 * Atomically create multiple projects under one fiscal quota.
 *
 * Used by the Excel import wizard. Resolves the fiscal quota once here so
 * the service can validate scope (only music quotas accept N projects) and
 * infer the incentive type from the beneficiary, mirroring the singular
 * create-project endpoint's split of responsibilities.
 */
export const createProjectsBulkForBeneficiary = <ThrowOnError extends boolean = false>(options: Options<CreateProjectsBulkForBeneficiaryData, ThrowOnError>): RequestResult<CreateProjectsBulkForBeneficiaryResponses, CreateProjectsBulkForBeneficiaryErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectsBulkForBeneficiaryResponses, CreateProjectsBulkForBeneficiaryErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateProjectsBulkForBeneficiaryResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/projects/actions/bulk-create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Project Poster
 *
 * Delete project poster (convenience endpoint — archives the document).
 */
export const deleteProjectPoster = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectPosterData, ThrowOnError>): RequestResult<DeleteProjectPosterResponses, DeleteProjectPosterErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectPosterResponses, DeleteProjectPosterErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteProjectPosterResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{project_uuid}/poster',
    ...options
});

/**
 * Get Project Poster
 *
 * Get project poster signed URL (convenience endpoint).
 */
export const getProjectPoster = <ThrowOnError extends boolean = false>(options: Options<GetProjectPosterData, ThrowOnError>): RequestResult<GetProjectPosterResponses, GetProjectPosterErrors, ThrowOnError> => (options.client ?? client).get<GetProjectPosterResponses, GetProjectPosterErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetProjectPosterResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{project_uuid}/poster',
    ...options
});

/**
 * Create Project Poster
 *
 * Upload a project poster (convenience endpoint).
 */
export const createProjectPoster = <ThrowOnError extends boolean = false>(options: Options<CreateProjectPosterData, ThrowOnError>): RequestResult<CreateProjectPosterResponses, CreateProjectPosterErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectPosterResponses, CreateProjectPosterErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zCreateProjectPosterResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{project_uuid}/poster',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Project Documents
 *
 * List documents for a project with pagination. Defaults to ACTIVE only.
 */
export const listProjectDocuments = <ThrowOnError extends boolean = false>(options: Options<ListProjectDocumentsData, ThrowOnError>): RequestResult<ListProjectDocumentsResponses, ListProjectDocumentsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectDocumentsResponses, ListProjectDocumentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListProjectDocumentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{project_uuid}/documents',
    ...options
});

/**
 * Upload Project Document
 *
 * Upload a document for a project.
 */
export const uploadProjectDocument = <ThrowOnError extends boolean = false>(options: Options<UploadProjectDocumentData, ThrowOnError>): RequestResult<UploadProjectDocumentResponses, UploadProjectDocumentErrors, ThrowOnError> => (options.client ?? client).post<UploadProjectDocumentResponses, UploadProjectDocumentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zUploadProjectDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{project_uuid}/documents',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Project Document
 *
 * Soft-delete a project document (archive).
 */
export const deleteProjectDocument = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectDocumentData, ThrowOnError>): RequestResult<DeleteProjectDocumentResponses, DeleteProjectDocumentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectDocumentResponses, DeleteProjectDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteProjectDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{project_uuid}/documents/{document_uuid}',
    ...options
});

/**
 * Get Project Document
 *
 * Get specific project document details with review status.
 */
export const getProjectDocument = <ThrowOnError extends boolean = false>(options: Options<GetProjectDocumentData, ThrowOnError>): RequestResult<GetProjectDocumentResponses, GetProjectDocumentErrors, ThrowOnError> => (options.client ?? client).get<GetProjectDocumentResponses, GetProjectDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetProjectDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{project_uuid}/documents/{document_uuid}',
    ...options
});

/**
 * Update Project Document
 *
 * Update project document metadata (title, description).
 */
export const updateProjectDocument = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectDocumentData, ThrowOnError>): RequestResult<UpdateProjectDocumentResponses, UpdateProjectDocumentErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProjectDocumentResponses, UpdateProjectDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateProjectDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{project_uuid}/documents/{document_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Project Document
 *
 * Get signed URL for downloading a project document.
 */
export const downloadProjectDocument = <ThrowOnError extends boolean = false>(options: Options<DownloadProjectDocumentData, ThrowOnError>): RequestResult<DownloadProjectDocumentResponses, DownloadProjectDocumentErrors, ThrowOnError> => (options.client ?? client).get<DownloadProjectDocumentResponses, DownloadProjectDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zDownloadProjectDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{project_uuid}/documents/{document_uuid}/download',
    ...options
});

/**
 * Review Project Document
 *
 * Approve or reject a project document review.
 */
export const reviewProjectDocument = <ThrowOnError extends boolean = false>(options: Options<ReviewProjectDocumentData, ThrowOnError>): RequestResult<ReviewProjectDocumentResponses, ReviewProjectDocumentErrors, ThrowOnError> => (options.client ?? client).post<ReviewProjectDocumentResponses, ReviewProjectDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zReviewProjectDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/projects/{project_uuid}/documents/{document_uuid}/actions/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Investor Metrics
 *
 * Get aggregated metrics for investors matching the filters.
 *
 * Returns summary KPIs (total count, by type, capacity metrics) that update
 * when filters are applied. Unlike the list endpoint, this aggregates across
 * the full filtered dataset without pagination.
 *
 * Use this endpoint in conjunction with the list endpoint to display
 * filtered KPI cards above the investors table.
 */
export const getInvestorMetrics = <ThrowOnError extends boolean = false>(options?: Options<GetInvestorMetricsData, ThrowOnError>): RequestResult<GetInvestorMetricsResponses, GetInvestorMetricsErrors, ThrowOnError> => (options?.client ?? client).get<GetInvestorMetricsResponses, GetInvestorMetricsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetInvestorMetricsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/metrics',
    ...options
});

/**
 * List Investors
 *
 * List investors with their investment summaries.
 *
 * Supports sorting by computed fields (total_investment, number_investments).
 *
 * Returns investors with nested investment_summary containing:
 * - number_investments: Total number of investments
 * - total_amount: Total investment amount
 * - reserved_amount: Amount in RESERVED state
 * - confirmed_amount: Amount in FUNDED/DECLARED states
 */
export const listInvestors = <ThrowOnError extends boolean = false>(options?: Options<ListInvestorsData, ThrowOnError>): RequestResult<ListInvestorsResponses, ListInvestorsErrors, ThrowOnError> => (options?.client ?? client).get<ListInvestorsResponses, ListInvestorsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListInvestorsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors',
    ...options
});

/**
 * Preview Investors Export
 *
 * Summary returned to the export modal before the user confirms.
 *
 * Includes the filtered row count, the column catalogue with translated
 * labels, and the active filter chips. The same query params accepted by
 * /investors and /investors/export are accepted here so the modal always
 * matches the table state.
 */
export const previewInvestorsExport = <ThrowOnError extends boolean = false>(options?: Options<PreviewInvestorsExportData, ThrowOnError>): RequestResult<PreviewInvestorsExportResponses, PreviewInvestorsExportErrors, ThrowOnError> => (options?.client ?? client).get<PreviewInvestorsExportResponses, PreviewInvestorsExportErrors, ThrowOnError>({
    responseValidator: async (data) => await zPreviewInvestorsExportResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/export/preview',
    ...options
});

/**
 * Export Investors
 *
 * Export all investors matching the filters.
 *
 * Default (no `format`, no `columns`) preserves the original behaviour:
 * a UTF-8 CSV with every column. The modal calls this endpoint with the
 * user's chosen format and selected column keys.
 */
export const exportInvestors = <ThrowOnError extends boolean = false>(options?: Options<ExportInvestorsData, ThrowOnError>): RequestResult<ExportInvestorsResponses, ExportInvestorsErrors, ThrowOnError> => (options?.client ?? client).get<ExportInvestorsResponses, ExportInvestorsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/export',
    ...options
});

/**
 * Create Individual Investor
 *
 * Create a new individual investor in the current organization.
 */
export const createIndividualInvestor = <ThrowOnError extends boolean = false>(options: Options<CreateIndividualInvestorData, ThrowOnError>): RequestResult<CreateIndividualInvestorResponses, CreateIndividualInvestorErrors, ThrowOnError> => (options.client ?? client).post<CreateIndividualInvestorResponses, CreateIndividualInvestorErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateIndividualInvestorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/individuals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Investor Music Deduction Summary
 *
 * Amount invested and deduction already transferred to this investor across
 * music quotas of the fiscal year (committed investments:
 * reserved/financing/funded/declared).
 *
 * Feeds the advisory warning in the investment form when the accumulated
 * deduction approaches the Art. 36.3 LIS cap of 500.000 € per taxpayer and
 * period. The platform only sees its own investments, so this never blocks.
 */
export const getInvestorMusicDeductionSummary = <ThrowOnError extends boolean = false>(options: Options<GetInvestorMusicDeductionSummaryData, ThrowOnError>): RequestResult<GetInvestorMusicDeductionSummaryResponses, GetInvestorMusicDeductionSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetInvestorMusicDeductionSummaryResponses, GetInvestorMusicDeductionSummaryErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetInvestorMusicDeductionSummaryResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/music-deduction-summary',
    ...options
});

/**
 * Get Individual Investor
 *
 * Get a specific individual investor by UUID.
 */
export const getIndividualInvestor = <ThrowOnError extends boolean = false>(options: Options<GetIndividualInvestorData, ThrowOnError>): RequestResult<GetIndividualInvestorResponses, GetIndividualInvestorErrors, ThrowOnError> => (options.client ?? client).get<GetIndividualInvestorResponses, GetIndividualInvestorErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetIndividualInvestorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/individuals/{investor_uuid}',
    ...options
});

/**
 * Update Individual Investor
 *
 * Update an individual investor.
 */
export const updateIndividualInvestor = <ThrowOnError extends boolean = false>(options: Options<UpdateIndividualInvestorData, ThrowOnError>): RequestResult<UpdateIndividualInvestorResponses, UpdateIndividualInvestorErrors, ThrowOnError> => (options.client ?? client).patch<UpdateIndividualInvestorResponses, UpdateIndividualInvestorErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateIndividualInvestorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/individuals/{investor_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Company Investor
 *
 * Create a new company investor in the current organization.
 */
export const createCompanyInvestor = <ThrowOnError extends boolean = false>(options: Options<CreateCompanyInvestorData, ThrowOnError>): RequestResult<CreateCompanyInvestorResponses, CreateCompanyInvestorErrors, ThrowOnError> => (options.client ?? client).post<CreateCompanyInvestorResponses, CreateCompanyInvestorErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateCompanyInvestorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/companies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Company Investor
 *
 * Get a specific company investor by UUID.
 */
export const getCompanyInvestor = <ThrowOnError extends boolean = false>(options: Options<GetCompanyInvestorData, ThrowOnError>): RequestResult<GetCompanyInvestorResponses, GetCompanyInvestorErrors, ThrowOnError> => (options.client ?? client).get<GetCompanyInvestorResponses, GetCompanyInvestorErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetCompanyInvestorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/companies/{investor_uuid}',
    ...options
});

/**
 * Update Company Investor
 *
 * Update a company investor.
 */
export const updateCompanyInvestor = <ThrowOnError extends boolean = false>(options: Options<UpdateCompanyInvestorData, ThrowOnError>): RequestResult<UpdateCompanyInvestorResponses, UpdateCompanyInvestorErrors, ThrowOnError> => (options.client ?? client).patch<UpdateCompanyInvestorResponses, UpdateCompanyInvestorErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateCompanyInvestorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/companies/{investor_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Investor
 *
 * Delete an investor (works for both individuals and companies).
 */
export const deleteInvestor = <ThrowOnError extends boolean = false>(options: Options<DeleteInvestorData, ThrowOnError>): RequestResult<DeleteInvestorResponses, DeleteInvestorErrors, ThrowOnError> => (options.client ?? client).delete<DeleteInvestorResponses, DeleteInvestorErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteInvestorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}',
    ...options
});

/**
 * Activate Investor
 *
 * Activate an investor (works for both individuals and companies).
 */
export const activateInvestor = <ThrowOnError extends boolean = false>(options: Options<ActivateInvestorData, ThrowOnError>): RequestResult<ActivateInvestorResponses, ActivateInvestorErrors, ThrowOnError> => (options.client ?? client).post<ActivateInvestorResponses, ActivateInvestorErrors, ThrowOnError>({
    responseValidator: async (data) => await zActivateInvestorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/actions/activate',
    ...options
});

/**
 * Deactivate Investor
 *
 * Deactivate an investor (works for both individuals and companies).
 */
export const deactivateInvestor = <ThrowOnError extends boolean = false>(options: Options<DeactivateInvestorData, ThrowOnError>): RequestResult<DeactivateInvestorResponses, DeactivateInvestorErrors, ThrowOnError> => (options.client ?? client).post<DeactivateInvestorResponses, DeactivateInvestorErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeactivateInvestorResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/actions/deactivate',
    ...options
});

/**
 * List Investor Legal Representatives
 *
 * Get all legal representatives for an investor.
 */
export const listInvestorLegalRepresentatives = <ThrowOnError extends boolean = false>(options: Options<ListInvestorLegalRepresentativesData, ThrowOnError>): RequestResult<ListInvestorLegalRepresentativesResponses, ListInvestorLegalRepresentativesErrors, ThrowOnError> => (options.client ?? client).get<ListInvestorLegalRepresentativesResponses, ListInvestorLegalRepresentativesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListInvestorLegalRepresentativesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/legal-representatives',
    ...options
});

/**
 * Create Investor Legal Representative
 *
 * Create a legal representative for an investor.
 */
export const createInvestorLegalRepresentative = <ThrowOnError extends boolean = false>(options: Options<CreateInvestorLegalRepresentativeData, ThrowOnError>): RequestResult<CreateInvestorLegalRepresentativeResponses, CreateInvestorLegalRepresentativeErrors, ThrowOnError> => (options.client ?? client).post<CreateInvestorLegalRepresentativeResponses, CreateInvestorLegalRepresentativeErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateInvestorLegalRepresentativeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/legal-representatives',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Investor Legal Representative
 *
 * Delete a legal representative.
 */
export const deleteInvestorLegalRepresentative = <ThrowOnError extends boolean = false>(options: Options<DeleteInvestorLegalRepresentativeData, ThrowOnError>): RequestResult<DeleteInvestorLegalRepresentativeResponses, DeleteInvestorLegalRepresentativeErrors, ThrowOnError> => (options.client ?? client).delete<DeleteInvestorLegalRepresentativeResponses, DeleteInvestorLegalRepresentativeErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteInvestorLegalRepresentativeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/legal-representatives/{representative_uuid}',
    ...options
});

/**
 * Update Investor Legal Representative
 *
 * Update a legal representative.
 */
export const updateInvestorLegalRepresentative = <ThrowOnError extends boolean = false>(options: Options<UpdateInvestorLegalRepresentativeData, ThrowOnError>): RequestResult<UpdateInvestorLegalRepresentativeResponses, UpdateInvestorLegalRepresentativeErrors, ThrowOnError> => (options.client ?? client).patch<UpdateInvestorLegalRepresentativeResponses, UpdateInvestorLegalRepresentativeErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateInvestorLegalRepresentativeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/legal-representatives/{representative_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set Primary Investor Legal Representative
 *
 * Set a legal representative as primary.
 */
export const setPrimaryInvestorLegalRepresentative = <ThrowOnError extends boolean = false>(options: Options<SetPrimaryInvestorLegalRepresentativeData, ThrowOnError>): RequestResult<SetPrimaryInvestorLegalRepresentativeResponses, SetPrimaryInvestorLegalRepresentativeErrors, ThrowOnError> => (options.client ?? client).post<SetPrimaryInvestorLegalRepresentativeResponses, SetPrimaryInvestorLegalRepresentativeErrors, ThrowOnError>({
    responseValidator: async (data) => await zSetPrimaryInvestorLegalRepresentativeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/legal-representatives/{representative_uuid}/actions/set-primary',
    ...options
});

/**
 * Invite Investor To Hub
 *
 * Invite an investor to access their self-service Hub portal.
 */
export const inviteInvestorToHub = <ThrowOnError extends boolean = false>(options: Options<InviteInvestorToHubData, ThrowOnError>): RequestResult<InviteInvestorToHubResponses, InviteInvestorToHubErrors, ThrowOnError> => (options.client ?? client).post<InviteInvestorToHubResponses, InviteInvestorToHubErrors, ThrowOnError>({
    responseValidator: async (data) => await zInviteInvestorToHubResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/actions/invite',
    ...options
});

/**
 * List Investor Documents
 *
 * Return every document relevant to an investor.
 *
 * The response partitions the matching documents into two sections:
 *
 * - ``owned``: documents whose ``entity_type=INVESTOR`` and ``entity_uuid``
 * matches the investor (passport, national_id, kyc_form, etc.).
 * - ``from_investments``: documents scoped to each investment the investor
 * is party of, grouped per investment with reference/state/amount/beneficiary.
 *
 * Filters (``doc_type``, ``status``, ``fiscal_quota_uuid``, ``search``) narrow the
 * result across both sections uniformly. Pagination applies to the flat
 * document set (ordered by ``uploaded_at DESC``) and the section layout is
 * rebuilt from whichever documents fit on the current page.
 *
 * Query count is constant regardless of how many investments the investor
 * has: a single batched query on the unified ``documents`` table.
 */
export const listInvestorDocuments = <ThrowOnError extends boolean = false>(options: Options<ListInvestorDocumentsData, ThrowOnError>): RequestResult<ListInvestorDocumentsResponses, ListInvestorDocumentsErrors, ThrowOnError> => (options.client ?? client).get<ListInvestorDocumentsResponses, ListInvestorDocumentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListInvestorDocumentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/documents',
    ...options
});

/**
 * Upload Investor Document
 *
 * Upload a document for an investor.
 */
export const uploadInvestorDocument = <ThrowOnError extends boolean = false>(options: Options<UploadInvestorDocumentData, ThrowOnError>): RequestResult<UploadInvestorDocumentResponses, UploadInvestorDocumentErrors, ThrowOnError> => (options.client ?? client).post<UploadInvestorDocumentResponses, UploadInvestorDocumentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zUploadInvestorDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/documents',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Investor Document
 *
 * Soft-delete an investor document (archive).
 */
export const deleteInvestorDocument = <ThrowOnError extends boolean = false>(options: Options<DeleteInvestorDocumentData, ThrowOnError>): RequestResult<DeleteInvestorDocumentResponses, DeleteInvestorDocumentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteInvestorDocumentResponses, DeleteInvestorDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteInvestorDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/documents/{document_uuid}',
    ...options
});

/**
 * Get Investor Document
 *
 * Get specific investor document details with review status.
 */
export const getInvestorDocument = <ThrowOnError extends boolean = false>(options: Options<GetInvestorDocumentData, ThrowOnError>): RequestResult<GetInvestorDocumentResponses, GetInvestorDocumentErrors, ThrowOnError> => (options.client ?? client).get<GetInvestorDocumentResponses, GetInvestorDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetInvestorDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/documents/{document_uuid}',
    ...options
});

/**
 * Update Investor Document
 *
 * Update investor document metadata (title, description).
 */
export const updateInvestorDocument = <ThrowOnError extends boolean = false>(options: Options<UpdateInvestorDocumentData, ThrowOnError>): RequestResult<UpdateInvestorDocumentResponses, UpdateInvestorDocumentErrors, ThrowOnError> => (options.client ?? client).patch<UpdateInvestorDocumentResponses, UpdateInvestorDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateInvestorDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/documents/{document_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Investor Document
 *
 * Get signed URL for downloading an investor document.
 */
export const downloadInvestorDocument = <ThrowOnError extends boolean = false>(options: Options<DownloadInvestorDocumentData, ThrowOnError>): RequestResult<DownloadInvestorDocumentResponses, DownloadInvestorDocumentErrors, ThrowOnError> => (options.client ?? client).get<DownloadInvestorDocumentResponses, DownloadInvestorDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zDownloadInvestorDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/documents/{document_uuid}/download',
    ...options
});

/**
 * Review Investor Document
 *
 * Approve or reject an investor document review.
 */
export const reviewInvestorDocument = <ThrowOnError extends boolean = false>(options: Options<ReviewInvestorDocumentData, ThrowOnError>): RequestResult<ReviewInvestorDocumentResponses, ReviewInvestorDocumentErrors, ThrowOnError> => (options.client ?? client).post<ReviewInvestorDocumentResponses, ReviewInvestorDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zReviewInvestorDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investors/{investor_uuid}/documents/{document_uuid}/actions/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Proposals
 *
 * List all investment proposals for the organization.
 * Requires authentication.
 */
export const listProposals = <ThrowOnError extends boolean = false>(options?: Options<ListProposalsData, ThrowOnError>): RequestResult<ListProposalsResponses, ListProposalsErrors, ThrowOnError> => (options?.client ?? client).get<ListProposalsResponses, ListProposalsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListProposalsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/proposals',
    ...options
});

/**
 * Create Proposal
 *
 * Create a new investment proposal.
 */
export const createProposal = <ThrowOnError extends boolean = false>(options: Options<CreateProposalData, ThrowOnError>): RequestResult<CreateProposalResponses, CreateProposalErrors, ThrowOnError> => (options.client ?? client).post<CreateProposalResponses, CreateProposalErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateProposalResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/proposals',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Proposal
 *
 * Get investment proposal by UUID with token verification.
 * Public endpoint - no authentication required.
 */
export const getProposal = <ThrowOnError extends boolean = false>(options: Options<GetProposalData, ThrowOnError>): RequestResult<GetProposalResponses, GetProposalErrors, ThrowOnError> => (options.client ?? client).get<GetProposalResponses, GetProposalErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetProposalResponse.parseAsync(data),
    url: '/api/v1/investments/proposals/{proposal_uuid}',
    ...options
});

/**
 * Accept Proposal
 *
 * Accept investment proposal by UUID with token verification.
 * Public endpoint - no authentication required.
 */
export const acceptProposal = <ThrowOnError extends boolean = false>(options: Options<AcceptProposalData, ThrowOnError>): RequestResult<AcceptProposalResponses, AcceptProposalErrors, ThrowOnError> => (options.client ?? client).post<AcceptProposalResponses, AcceptProposalErrors, ThrowOnError>({
    responseValidator: async (data) => await zAcceptProposalResponse.parseAsync(data),
    url: '/api/v1/investments/proposals/{proposal_uuid}/actions/accept',
    ...options
});

/**
 * Decline Proposal
 *
 * Decline investment proposal by UUID with token verification.
 * Public endpoint - no authentication required.
 */
export const declineProposal = <ThrowOnError extends boolean = false>(options: Options<DeclineProposalData, ThrowOnError>): RequestResult<DeclineProposalResponses, DeclineProposalErrors, ThrowOnError> => (options.client ?? client).post<DeclineProposalResponses, DeclineProposalErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeclineProposalResponse.parseAsync(data),
    url: '/api/v1/investments/proposals/{proposal_uuid}/actions/decline',
    ...options
});

/**
 * Extend Reservation
 *
 * Extend investment reservation expiry date.
 *
 * This action only handles notifications and event creation.
 * The actual expiry date update must be done separately via PATCH /investments/{uuid}.
 */
export const extendReservation = <ThrowOnError extends boolean = false>(options: Options<ExtendReservationData, ThrowOnError>): RequestResult<ExtendReservationResponses, ExtendReservationErrors, ThrowOnError> => (options.client ?? client).post<ExtendReservationResponses, ExtendReservationErrors, ThrowOnError>({
    responseValidator: async (data) => await zExtendReservationResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/actions/extend-reservation',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Reservation Contract
 *
 * Persist a reservation contract and enqueue its dispatch.
 *
 * The synchronous work (PDF render + GCS upload + DB writes + outbox
 * event) finishes before the 202 is returned. The envelope is created
 * by the api-events push handler — the response carries no
 * ``docusign_envelope_id``. Clients should observe ``signature_status``
 * on the document/contract list to see ``pending → sent`` (or
 * ``failed`` with a retry option).
 */
export const sendReservationContract = <ThrowOnError extends boolean = false>(options: Options<SendReservationContractData, ThrowOnError>): RequestResult<SendReservationContractResponses, SendReservationContractErrors, ThrowOnError> => (options.client ?? client).post<SendReservationContractResponses, SendReservationContractErrors, ThrowOnError>({
    responseValidator: async (data) => await zSendReservationContractResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/actions/send-reservation-contract',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Reservation Contract
 *
 * Generate a preview of the reservation contract PDF without saving or sending it.
 *
 * Returns the PDF directly for preview purposes. Does not create any database records
 * or send via DocuSign.
 */
export const previewReservationContract = <ThrowOnError extends boolean = false>(options: Options<PreviewReservationContractData, ThrowOnError>): RequestResult<PreviewReservationContractResponses, PreviewReservationContractErrors, ThrowOnError> => (options.client ?? client).post<PreviewReservationContractResponses, PreviewReservationContractErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/actions/preview-reservation-contract',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resend Document
 *
 * Resend document to signers who haven't signed yet.
 *
 * DocuSign will automatically send reminder emails to pending signers only.
 * Already-signed recipients won't receive anything.
 */
export const resendDocument = <ThrowOnError extends boolean = false>(options: Options<ResendDocumentData, ThrowOnError>): RequestResult<ResendDocumentResponses, ResendDocumentErrors, ThrowOnError> => (options.client ?? client).post<ResendDocumentResponses, ResendDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zResendDocumentResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/documents/{document_uuid}/actions/resend',
    ...options
});

/**
 * Send Financing Contract
 *
 * Persist a financing contract and enqueue its dispatch.
 *
 * See ``send_reservation_contract`` for the async semantics.
 */
export const sendFinancingContract = <ThrowOnError extends boolean = false>(options: Options<SendFinancingContractData, ThrowOnError>): RequestResult<SendFinancingContractResponses, SendFinancingContractErrors, ThrowOnError> => (options.client ?? client).post<SendFinancingContractResponses, SendFinancingContractErrors, ThrowOnError>({
    responseValidator: async (data) => await zSendFinancingContractResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/actions/send-financing-contract',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Financing Contract
 *
 * Generate a preview of the financing contract PDF without saving or sending it.
 *
 * Returns the PDF directly for preview purposes. Does not create any database records
 * or send via DocuSign.
 */
export const previewFinancingContract = <ThrowOnError extends boolean = false>(options: Options<PreviewFinancingContractData, ThrowOnError>): RequestResult<PreviewFinancingContractResponses, PreviewFinancingContractErrors, ThrowOnError> => (options.client ?? client).post<PreviewFinancingContractResponses, PreviewFinancingContractErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/actions/preview-financing-contract',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Communication Contract
 *
 * Persist a communication contract and enqueue its dispatch.
 *
 * See ``send_reservation_contract`` for the async semantics.
 */
export const sendCommunicationContract = <ThrowOnError extends boolean = false>(options: Options<SendCommunicationContractData, ThrowOnError>): RequestResult<SendCommunicationContractResponses, SendCommunicationContractErrors, ThrowOnError> => (options.client ?? client).post<SendCommunicationContractResponses, SendCommunicationContractErrors, ThrowOnError>({
    responseValidator: async (data) => await zSendCommunicationContractResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/actions/send-communication-contract',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retry Contract Dispatch
 *
 * Retry a failed contract dispatch.
 *
 * Valid only when the signature row is ``FAILED`` (the provider refused
 * the request) or stuck in ``PENDING`` with no envelope_id (the
 * original dispatch was lost before completing). For envelopes that
 * were created but recipients haven't signed, use the resend endpoint
 * on ``/documents/{document_uuid}/actions/resend`` instead.
 */
export const retryContractDispatch = <ThrowOnError extends boolean = false>(options: Options<RetryContractDispatchData, ThrowOnError>): RequestResult<RetryContractDispatchResponses, RetryContractDispatchErrors, ThrowOnError> => (options.client ?? client).post<RetryContractDispatchResponses, RetryContractDispatchErrors, ThrowOnError>({
    responseValidator: async (data) => await zRetryContractDispatchResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/documents/{document_uuid}/actions/retry-dispatch',
    ...options
});

/**
 * Preview Communication Contract
 *
 * Generate a preview of the communication contract PDF without saving or sending it.
 */
export const previewCommunicationContract = <ThrowOnError extends boolean = false>(options: Options<PreviewCommunicationContractData, ThrowOnError>): RequestResult<PreviewCommunicationContractResponses, PreviewCommunicationContractErrors, ThrowOnError> => (options.client ?? client).post<PreviewCommunicationContractResponses, PreviewCommunicationContractErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/actions/preview-communication-contract',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Void Contract
 *
 * Void a contract document.
 *
 * Sets the document status to rejected and cancels the DocuSign envelope
 * if it's still active. Creates audit trail of the voiding action.
 */
export const voidContract = <ThrowOnError extends boolean = false>(options: Options<VoidContractData, ThrowOnError>): RequestResult<VoidContractResponses, VoidContractErrors, ThrowOnError> => (options.client ?? client).post<VoidContractResponses, VoidContractErrors, ThrowOnError>({
    responseValidator: async (data) => await zVoidContractResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/actions/void-contract',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Aeat Documents
 *
 * Download AEAT documents as a ZIP archive.
 *
 * Downloads selected documents (communication contract, financing contract,
 * INAEM certificate) as a single ZIP file.
 *
 * Requirements:
 * - Investment must be in FUNDED or DECLARED state
 * - At least one document must be selected
 */
export const downloadAeatDocuments = <ThrowOnError extends boolean = false>(options: Options<DownloadAeatDocumentsData, ThrowOnError>): RequestResult<DownloadAeatDocumentsResponses, DownloadAeatDocumentsErrors, ThrowOnError> => (options.client ?? client).post<DownloadAeatDocumentsResponses, DownloadAeatDocumentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/actions/download-aeat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Investments
 *
 * List all investments for the organization with filtering, sorting, and pagination.
 *
 * Supports filtering by state, investor, beneficiary, fiscal quota, search query,
 * amount range, and archived status. Results can be sorted by amount,
 * return_percentage, created_at, or state.
 */
export const listInvestments = <ThrowOnError extends boolean = false>(options?: Options<ListInvestmentsData, ThrowOnError>): RequestResult<ListInvestmentsResponses, ListInvestmentsErrors, ThrowOnError> => (options?.client ?? client).get<ListInvestmentsResponses, ListInvestmentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListInvestmentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments',
    ...options
});

/**
 * Create Investment
 *
 * Create a new investment.
 */
export const createInvestment = <ThrowOnError extends boolean = false>(options: Options<CreateInvestmentData, ThrowOnError>): RequestResult<CreateInvestmentResponses, CreateInvestmentErrors, ThrowOnError> => (options.client ?? client).post<CreateInvestmentResponses, CreateInvestmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateInvestmentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Investments Export
 *
 * Summary returned to the export modal before the user confirms.
 */
export const previewInvestmentsExport = <ThrowOnError extends boolean = false>(options?: Options<PreviewInvestmentsExportData, ThrowOnError>): RequestResult<PreviewInvestmentsExportResponses, PreviewInvestmentsExportErrors, ThrowOnError> => (options?.client ?? client).get<PreviewInvestmentsExportResponses, PreviewInvestmentsExportErrors, ThrowOnError>({
    responseValidator: async (data) => await zPreviewInvestmentsExportResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/export/preview',
    ...options
});

/**
 * Export Investments
 *
 * Export all investments matching the filters in the requested format.
 */
export const exportInvestments = <ThrowOnError extends boolean = false>(options?: Options<ExportInvestmentsData, ThrowOnError>): RequestResult<ExportInvestmentsResponses, ExportInvestmentsErrors, ThrowOnError> => (options?.client ?? client).get<ExportInvestmentsResponses, ExportInvestmentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/export',
    ...options
});

/**
 * Delete Investment
 *
 * Delete an investment.
 */
export const deleteInvestment = <ThrowOnError extends boolean = false>(options: Options<DeleteInvestmentData, ThrowOnError>): RequestResult<DeleteInvestmentResponses, DeleteInvestmentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteInvestmentResponses, DeleteInvestmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteInvestmentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}',
    ...options
});

/**
 * Get Investment
 *
 * Get investment with all details including related entities.
 */
export const getInvestment = <ThrowOnError extends boolean = false>(options: Options<GetInvestmentData, ThrowOnError>): RequestResult<GetInvestmentResponses, GetInvestmentErrors, ThrowOnError> => (options.client ?? client).get<GetInvestmentResponses, GetInvestmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetInvestmentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}',
    ...options
});

/**
 * Update Investment
 *
 * Update investment basic information.
 */
export const updateInvestment = <ThrowOnError extends boolean = false>(options: Options<UpdateInvestmentData, ThrowOnError>): RequestResult<UpdateInvestmentResponses, UpdateInvestmentErrors, ThrowOnError> => (options.client ?? client).patch<UpdateInvestmentResponses, UpdateInvestmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateInvestmentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Investment Documents
 *
 * List documents for an investment with pagination. Defaults to ACTIVE only.
 */
export const listInvestmentDocuments = <ThrowOnError extends boolean = false>(options: Options<ListInvestmentDocumentsData, ThrowOnError>): RequestResult<ListInvestmentDocumentsResponses, ListInvestmentDocumentsErrors, ThrowOnError> => (options.client ?? client).get<ListInvestmentDocumentsResponses, ListInvestmentDocumentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListInvestmentDocumentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/documents',
    ...options
});

/**
 * Upload Investment Document
 *
 * Upload a document for an investment.
 */
export const uploadInvestmentDocument = <ThrowOnError extends boolean = false>(options: Options<UploadInvestmentDocumentData, ThrowOnError>): RequestResult<UploadInvestmentDocumentResponses, UploadInvestmentDocumentErrors, ThrowOnError> => (options.client ?? client).post<UploadInvestmentDocumentResponses, UploadInvestmentDocumentErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zUploadInvestmentDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/documents',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Investment Document
 *
 * Soft-delete a document from an investment (archive).
 */
export const deleteInvestmentDocument = <ThrowOnError extends boolean = false>(options: Options<DeleteInvestmentDocumentData, ThrowOnError>): RequestResult<DeleteInvestmentDocumentResponses, DeleteInvestmentDocumentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteInvestmentDocumentResponses, DeleteInvestmentDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteInvestmentDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/documents/{document_uuid}',
    ...options
});

/**
 * Get Investment Document
 *
 * Get specific document details for an investment with review and signature status.
 */
export const getInvestmentDocument = <ThrowOnError extends boolean = false>(options: Options<GetInvestmentDocumentData, ThrowOnError>): RequestResult<GetInvestmentDocumentResponses, GetInvestmentDocumentErrors, ThrowOnError> => (options.client ?? client).get<GetInvestmentDocumentResponses, GetInvestmentDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetInvestmentDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/documents/{document_uuid}',
    ...options
});

/**
 * Update Investment Document
 *
 * Update investment document metadata (title, description).
 */
export const updateInvestmentDocument = <ThrowOnError extends boolean = false>(options: Options<UpdateInvestmentDocumentData, ThrowOnError>): RequestResult<UpdateInvestmentDocumentResponses, UpdateInvestmentDocumentErrors, ThrowOnError> => (options.client ?? client).patch<UpdateInvestmentDocumentResponses, UpdateInvestmentDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateInvestmentDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/documents/{document_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Investment Document
 *
 * Get signed URL for downloading an investment document.
 */
export const downloadInvestmentDocument = <ThrowOnError extends boolean = false>(options: Options<DownloadInvestmentDocumentData, ThrowOnError>): RequestResult<DownloadInvestmentDocumentResponses, DownloadInvestmentDocumentErrors, ThrowOnError> => (options.client ?? client).get<DownloadInvestmentDocumentResponses, DownloadInvestmentDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zDownloadInvestmentDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/documents/{document_uuid}/download',
    ...options
});

/**
 * Review Investment Document
 *
 * Approve or reject an investment document review.
 */
export const reviewInvestmentDocument = <ThrowOnError extends boolean = false>(options: Options<ReviewInvestmentDocumentData, ThrowOnError>): RequestResult<ReviewInvestmentDocumentResponses, ReviewInvestmentDocumentErrors, ThrowOnError> => (options.client ?? client).post<ReviewInvestmentDocumentResponses, ReviewInvestmentDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zReviewInvestmentDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/investments/{investment_uuid}/documents/{document_uuid}/actions/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Expense Audit
 *
 * Render and persist the expense audit report for a fiscal quota.
 *
 * The figures come from the live classifier aggregation (same source as
 * the classifier overview tab) — never the consolidated_* snapshot —
 * so the report cannot drift from what the asesor sees on screen.
 *
 * Returns the PDF bytes inline so the client can pipe them straight
 * into a download. The persisted Document metadata is surfaced via
 * custom ``X-Document-*`` headers for callers that need it.
 */
export const generateExpenseAudit = <ThrowOnError extends boolean = false>(options: Options<GenerateExpenseAuditData, ThrowOnError>): RequestResult<GenerateExpenseAuditResponses, GenerateExpenseAuditErrors, ThrowOnError> => (options.client ?? client).post<GenerateExpenseAuditResponses, GenerateExpenseAuditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/fiscal-quotas/{fiscal_quota_uuid}/actions/generate-expense-audit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Expense Audit
 *
 * Render the audit PDF for a fiscal quota without persisting Document nor uploading to GCS.
 *
 * Returns the PDF bytes inline so the frontend can pin it into an
 * ``<iframe>``/``<object>`` for the preview pane. Mirrors the
 * ``preview-financing-contract`` pattern.
 */
export const previewExpenseAudit = <ThrowOnError extends boolean = false>(options: Options<PreviewExpenseAuditData, ThrowOnError>): RequestResult<PreviewExpenseAuditResponses, PreviewExpenseAuditErrors, ThrowOnError> => (options.client ?? client).post<PreviewExpenseAuditResponses, PreviewExpenseAuditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/fiscal-quotas/{fiscal_quota_uuid}/actions/preview-expense-audit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Contracts
 *
 * List all contracts across investments with filters.
 *
 * Returns contract summaries with signer information and signature status.
 * Useful for getting an overview of all contracts in the organization.
 */
export const listContracts = <ThrowOnError extends boolean = false>(options?: Options<ListContractsData, ThrowOnError>): RequestResult<ListContractsResponses, ListContractsErrors, ThrowOnError> => (options?.client ?? client).get<ListContractsResponses, ListContractsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListContractsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/contracts',
    ...options
});

/**
 * Get Contract Stats
 *
 * Get contract statistics with optional filters.
 *
 * Returns aggregate counts by status and type using efficient COUNT queries.
 * Does not load actual contract documents.
 */
export const getContractStats = <ThrowOnError extends boolean = false>(options?: Options<GetContractStatsData, ThrowOnError>): RequestResult<GetContractStatsResponses, GetContractStatsErrors, ThrowOnError> => (options?.client ?? client).get<GetContractStatsResponses, GetContractStatsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetContractStatsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/contracts/stats',
    ...options
});

/**
 * Get Contract Details
 *
 * Get detailed information about a specific contract.
 *
 * Returns comprehensive contract details including:
 * - Signer information with individual status
 * - Signature progress
 * - Investment context
 * - Document metadata
 */
export const getContractDetails = <ThrowOnError extends boolean = false>(options: Options<GetContractDetailsData, ThrowOnError>): RequestResult<GetContractDetailsResponses, GetContractDetailsErrors, ThrowOnError> => (options.client ?? client).get<GetContractDetailsResponses, GetContractDetailsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetContractDetailsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/contracts/{contract_uuid}',
    ...options
});

/**
 * Get Contract Document
 *
 * Get contract document with signed URL for secure access.
 *
 * Returns document information including a time-limited signed URL
 * that can be used to download or view the contract document.
 */
export const getContractDocument = <ThrowOnError extends boolean = false>(options: Options<GetContractDocumentData, ThrowOnError>): RequestResult<GetContractDocumentResponses, GetContractDocumentErrors, ThrowOnError> => (options.client ?? client).get<GetContractDocumentResponses, GetContractDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetContractDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/contracts/{contract_uuid}/download',
    ...options
});

/**
 * List Templates
 *
 * List all templates available for organization (system + custom).
 */
export const listTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListTemplatesData, ThrowOnError>): RequestResult<ListTemplatesResponses, ListTemplatesErrors, ThrowOnError> => (options?.client ?? client).get<ListTemplatesResponses, ListTemplatesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListTemplatesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates',
    ...options
});

/**
 * Create Template
 *
 * Create a new template from scratch.
 */
export const createTemplate = <ThrowOnError extends boolean = false>(options: Options<CreateTemplateData, ThrowOnError>): RequestResult<CreateTemplateResponses, CreateTemplateErrors, ThrowOnError> => (options.client ?? client).post<CreateTemplateResponses, CreateTemplateErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateTemplateResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Template
 *
 * Delete an organization template.
 */
export const deleteTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteTemplateData, ThrowOnError>): RequestResult<DeleteTemplateResponses, DeleteTemplateErrors, ThrowOnError> => (options.client ?? client).delete<DeleteTemplateResponses, DeleteTemplateErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteTemplateResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates/{template_uuid}',
    ...options
});

/**
 * Get Template
 *
 * Get template detail including document content.
 */
export const getTemplate = <ThrowOnError extends boolean = false>(options: Options<GetTemplateData, ThrowOnError>): RequestResult<GetTemplateResponses, GetTemplateErrors, ThrowOnError> => (options.client ?? client).get<GetTemplateResponses, GetTemplateErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetTemplateResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates/{template_uuid}',
    ...options
});

/**
 * Update Template
 *
 * Update template metadata and/or content.
 */
export const updateTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateTemplateData, ThrowOnError>): RequestResult<UpdateTemplateResponses, UpdateTemplateErrors, ThrowOnError> => (options.client ?? client).patch<UpdateTemplateResponses, UpdateTemplateErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateTemplateResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates/{template_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Duplicate Template
 *
 * Duplicate an existing template for the organization.
 */
export const duplicateTemplate = <ThrowOnError extends boolean = false>(options: Options<DuplicateTemplateData, ThrowOnError>): RequestResult<DuplicateTemplateResponses, DuplicateTemplateErrors, ThrowOnError> => (options.client ?? client).post<DuplicateTemplateResponses, DuplicateTemplateErrors, ThrowOnError>({
    responseValidator: async (data) => await zDuplicateTemplateResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates/{template_uuid}/actions/duplicate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Template Image
 *
 * Upload an image used inside an ImageBlock of the given template.
 *
 * The client posts a base64 data URI; the server stores the binary in GCS
 * under ``organizations/{org}/templates/{template}/images/``, returns both
 * the persisted ``gs://`` URL (goes into ``attrs.src``) and a short-lived
 * signed URL (so the editor can render the image immediately).
 */
export const uploadTemplateImage = <ThrowOnError extends boolean = false>(options: Options<UploadTemplateImageData, ThrowOnError>): RequestResult<UploadTemplateImageResponses, UploadTemplateImageErrors, ThrowOnError> => (options.client ?? client).post<UploadTemplateImageResponses, UploadTemplateImageErrors, ThrowOnError>({
    responseValidator: async (data) => await zUploadTemplateImageResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates/{template_uuid}/images',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Template Image Preview
 *
 * Return a short-lived signed URL for an ImageBlock src.
 *
 * The editor calls this on mount for each ImageBlock so it can drop the
 * HTTPS URL into an ``<img>`` tag. Ownership is enforced and the src must
 * belong to the requested template's image folder.
 */
export const getTemplateImagePreview = <ThrowOnError extends boolean = false>(options: Options<GetTemplateImagePreviewData, ThrowOnError>): RequestResult<GetTemplateImagePreviewResponses, GetTemplateImagePreviewErrors, ThrowOnError> => (options.client ?? client).post<GetTemplateImagePreviewResponses, GetTemplateImagePreviewErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetTemplateImagePreviewResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates/{template_uuid}/images/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview Template
 *
 * Render the template to PDF using mock data drawn from the catalog.
 *
 * Used by the editor's "Vista previa PDF" action. No Investment/Investor
 * context is consulted — every placeholder is replaced with a static
 * example value, so the author can see how the document looks without
 * creating a real contract.
 */
export const previewTemplate = <ThrowOnError extends boolean = false>(options: Options<PreviewTemplateData, ThrowOnError>): RequestResult<PreviewTemplateResponses, PreviewTemplateErrors, ThrowOnError> => (options.client ?? client).get<PreviewTemplateResponses, PreviewTemplateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates/{template_uuid}/preview',
    ...options
});

/**
 * Get Template Compatibility
 *
 * Computed compatibility of the template with a document-generating act.
 *
 * Without ``action``, only validates the template's keys against the
 * catalog (editor dry-run: detects stale keys). With ``action``, also
 * reports the keys that act cannot resolve. With ``include_annexes`` and
 * an ``investment_uuid``, verifies the declared PDF annexes exist for
 * that investment (1-2 queries) — what the template selector shows as
 * "requires the signed financing contract".
 */
export const getTemplateCompatibility = <ThrowOnError extends boolean = false>(options: Options<GetTemplateCompatibilityData, ThrowOnError>): RequestResult<GetTemplateCompatibilityResponses, GetTemplateCompatibilityErrors, ThrowOnError> => (options.client ?? client).get<GetTemplateCompatibilityResponses, GetTemplateCompatibilityErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetTemplateCompatibilityResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/templates/{template_uuid}/compatibility',
    ...options
});

/**
 * Get Catalog
 *
 * Return the catalog split into fields and blocks, optionally filtered by group names.
 */
export const getCatalog = <ThrowOnError extends boolean = false>(options?: Options<GetCatalogData, ThrowOnError>): RequestResult<GetCatalogResponses, GetCatalogErrors, ThrowOnError> => (options?.client ?? client).get<GetCatalogResponses, GetCatalogErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetCatalogResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/placeholders/catalog',
    ...options
});

/**
 * Get Dashboard Metrics
 *
 * Get comprehensive dashboard metrics for operational overview.
 */
export const getDashboardMetrics = <ThrowOnError extends boolean = false>(options?: Options<GetDashboardMetricsData, ThrowOnError>): RequestResult<GetDashboardMetricsResponses, GetDashboardMetricsErrors, ThrowOnError> => (options?.client ?? client).get<GetDashboardMetricsResponses, GetDashboardMetricsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetDashboardMetricsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dashboard/metrics',
    ...options
});

/**
 * Get Investment Metrics
 *
 * Get investment metrics with optional filters and grouping.
 */
export const getInvestmentMetrics = <ThrowOnError extends boolean = false>(options?: Options<GetInvestmentMetricsData, ThrowOnError>): RequestResult<GetInvestmentMetricsResponses, GetInvestmentMetricsErrors, ThrowOnError> => (options?.client ?? client).get<GetInvestmentMetricsResponses, GetInvestmentMetricsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetInvestmentMetricsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/dashboard/investments',
    ...options
});

/**
 * Query Agent
 *
 * Process a natural language query about platform data or legislation.
 *
 * Requires an active AI Agent module entitlement for the organization.
 * Enforces daily token quotas per user.
 */
export const queryAgent = <ThrowOnError extends boolean = false>(options: Options<QueryAgentData, ThrowOnError>): RequestResult<QueryAgentResponses, QueryAgentErrors, ThrowOnError> => (options.client ?? client).post<QueryAgentResponses, QueryAgentErrors, ThrowOnError>({
    responseValidator: async (data) => await zQueryAgentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agent/query',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit Feedback
 *
 * Submit thumbs-up/down feedback for an AI agent response.
 *
 * Always returns 204 even if storage fails (fire-and-forget).
 */
export const submitFeedback = <ThrowOnError extends boolean = false>(options: Options<SubmitFeedbackData, ThrowOnError>): RequestResult<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError> => (options.client ?? client).post<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError>({
    responseValidator: async (data) => await zSubmitFeedbackResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/agent/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Org Entitlements
 *
 * Return the active module entitlements for the current organization.
 */
export const getOrgEntitlements = <ThrowOnError extends boolean = false>(options?: Options<GetOrgEntitlementsData, ThrowOnError>): RequestResult<GetOrgEntitlementsResponses, GetOrgEntitlementsErrors, ThrowOnError> => (options?.client ?? client).get<GetOrgEntitlementsResponses, GetOrgEntitlementsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetOrgEntitlementsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/modules/entitlements',
    ...options
});

/**
 * Create Upload Session
 *
 * Create an upload session with signed PUT URLs for direct GCS upload.
 */
export const createUploadSession = <ThrowOnError extends boolean = false>(options: Options<CreateUploadSessionData, ThrowOnError>): RequestResult<CreateUploadSessionResponses, CreateUploadSessionErrors, ThrowOnError> => (options.client ?? client).post<CreateUploadSessionResponses, CreateUploadSessionErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateUploadSessionResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/upload-session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sign Upload Batch
 *
 * Sign upload URLs for a batch of a deferred session's files (max 500 per call).
 */
export const signUploadBatch = <ThrowOnError extends boolean = false>(options: Options<SignUploadBatchData, ThrowOnError>): RequestResult<SignUploadBatchResponses, SignUploadBatchErrors, ThrowOnError> => (options.client ?? client).post<SignUploadBatchResponses, SignUploadBatchErrors, ThrowOnError>({
    responseValidator: async (data) => await zSignUploadBatchResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/upload-session/{session_uuid}/signed-urls',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Upload Session Status
 *
 * Get upload session progress.
 */
export const getUploadSessionStatus = <ThrowOnError extends boolean = false>(options: Options<GetUploadSessionStatusData, ThrowOnError>): RequestResult<GetUploadSessionStatusResponses, GetUploadSessionStatusErrors, ThrowOnError> => (options.client ?? client).get<GetUploadSessionStatusResponses, GetUploadSessionStatusErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetUploadSessionStatusResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/sessions/{session_uuid}',
    ...options
});

/**
 * List Classifications
 *
 * List classifications for a beneficiary with optional filters.
 */
export const listClassifications = <ThrowOnError extends boolean = false>(options: Options<ListClassificationsData, ThrowOnError>): RequestResult<ListClassificationsResponses, ListClassificationsErrors, ThrowOnError> => (options.client ?? client).get<ListClassificationsResponses, ListClassificationsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListClassificationsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications',
    ...options
});

/**
 * Preview Classifications Export
 *
 * Preview returned to the export modal before the user confirms.
 *
 * Mirrors the classifier list query params so the modal exports exactly
 * the dataset the user is currently filtering.
 */
export const previewClassificationsExport = <ThrowOnError extends boolean = false>(options: Options<PreviewClassificationsExportData, ThrowOnError>): RequestResult<PreviewClassificationsExportResponses, PreviewClassificationsExportErrors, ThrowOnError> => (options.client ?? client).get<PreviewClassificationsExportResponses, PreviewClassificationsExportErrors, ThrowOnError>({
    responseValidator: async (data) => await zPreviewClassificationsExportResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/export/preview',
    ...options
});

/**
 * Export Classifications
 *
 * Export the filtered classification set in the requested format.
 */
export const exportClassifications = <ThrowOnError extends boolean = false>(options: Options<ExportClassificationsData, ThrowOnError>): RequestResult<ExportClassificationsResponses, ExportClassificationsErrors, ThrowOnError> => (options.client ?? client).get<ExportClassificationsResponses, ExportClassificationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/export',
    ...options
});

/**
 * Get Classification Stats
 *
 * Count classifications grouped by document type, respecting active filters.
 */
export const getClassificationStats = <ThrowOnError extends boolean = false>(options: Options<GetClassificationStatsData, ThrowOnError>): RequestResult<GetClassificationStatsResponses, GetClassificationStatsErrors, ThrowOnError> => (options.client ?? client).get<GetClassificationStatsResponses, GetClassificationStatsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetClassificationStatsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/stats',
    ...options
});

/**
 * List Rule Ids
 *
 * Distinct F3 rule_ids seen in this beneficiary's classifications,
 * ordered by frequency desc. Powers the async `rule_id` filter dropdown
 * in the review queue.
 */
export const listRuleIds = <ThrowOnError extends boolean = false>(options: Options<ListRuleIdsData, ThrowOnError>): RequestResult<ListRuleIdsResponses, ListRuleIdsErrors, ThrowOnError> => (options.client ?? client).get<ListRuleIdsResponses, ListRuleIdsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListRuleIdsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/rule-ids',
    ...options
});

/**
 * Get Classification Summary
 *
 * Get aggregated analytics summary for a beneficiary's classifications.
 */
export const getClassificationSummary = <ThrowOnError extends boolean = false>(options: Options<GetClassificationSummaryData, ThrowOnError>): RequestResult<GetClassificationSummaryResponses, GetClassificationSummaryErrors, ThrowOnError> => (options.client ?? client).get<GetClassificationSummaryResponses, GetClassificationSummaryErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetClassificationSummaryResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/summary',
    ...options
});

/**
 * Get Classification Pipeline Status
 *
 * Pipeline-status counts for a beneficiary's classifications, whole scope.
 *
 * Lightweight heartbeat for the classifier view: the frontend polls this while
 * any document is QUEUED/PROCESSING and drives the refetch cadence of the list,
 * summary and analytics queries off it. Deliberately unfiltered — not even by
 * fiscal quota — so the heartbeat reflects *any* in-flight work for the
 * beneficiary and never switches off while documents are still processing
 * under a different filter.
 */
export const getClassificationPipelineStatus = <ThrowOnError extends boolean = false>(options: Options<GetClassificationPipelineStatusData, ThrowOnError>): RequestResult<GetClassificationPipelineStatusResponses, GetClassificationPipelineStatusErrors, ThrowOnError> => (options.client ?? client).get<GetClassificationPipelineStatusResponses, GetClassificationPipelineStatusErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetClassificationPipelineStatusResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/pipeline-status',
    ...options
});

/**
 * Get Suppliers Analytics
 *
 * Get top suppliers analytics for a beneficiary's invoice classifications.
 */
export const getSuppliersAnalytics = <ThrowOnError extends boolean = false>(options: Options<GetSuppliersAnalyticsData, ThrowOnError>): RequestResult<GetSuppliersAnalyticsResponses, GetSuppliersAnalyticsErrors, ThrowOnError> => (options.client ?? client).get<GetSuppliersAnalyticsResponses, GetSuppliersAnalyticsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetSuppliersAnalyticsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/analytics/suppliers',
    ...options
});

/**
 * Get Tax Breakdown
 *
 * Get IVA/IRPF tax breakdown from invoice classifications.
 */
export const getTaxBreakdown = <ThrowOnError extends boolean = false>(options: Options<GetTaxBreakdownData, ThrowOnError>): RequestResult<GetTaxBreakdownResponses, GetTaxBreakdownErrors, ThrowOnError> => (options.client ?? client).get<GetTaxBreakdownResponses, GetTaxBreakdownErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetTaxBreakdownResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/analytics/tax-breakdown',
    ...options
});

/**
 * Get Workforce Analytics
 *
 * Get workforce/payroll analytics from payroll classifications.
 */
export const getWorkforceAnalytics = <ThrowOnError extends boolean = false>(options: Options<GetWorkforceAnalyticsData, ThrowOnError>): RequestResult<GetWorkforceAnalyticsResponses, GetWorkforceAnalyticsErrors, ThrowOnError> => (options.client ?? client).get<GetWorkforceAnalyticsResponses, GetWorkforceAnalyticsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetWorkforceAnalyticsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/analytics/workforce',
    ...options
});

/**
 * Delete Classification
 *
 * Soft-delete a classification and remove its GCS blob.
 */
export const deleteClassification = <ThrowOnError extends boolean = false>(options: Options<DeleteClassificationData, ThrowOnError>): RequestResult<DeleteClassificationResponses, DeleteClassificationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteClassificationResponses, DeleteClassificationErrors, ThrowOnError>({
    responseValidator: async (data) => await zDeleteClassificationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/{classification_uuid}',
    ...options
});

/**
 * Get Classification
 *
 * Get a single classification by UUID.
 */
export const getClassification = <ThrowOnError extends boolean = false>(options: Options<GetClassificationData, ThrowOnError>): RequestResult<GetClassificationResponses, GetClassificationErrors, ThrowOnError> => (options.client ?? client).get<GetClassificationResponses, GetClassificationErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetClassificationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/{classification_uuid}',
    ...options
});

/**
 * Update Classification
 *
 * Update classification data (extracted fields, categorization, qualification).
 */
export const updateClassification = <ThrowOnError extends boolean = false>(options: Options<UpdateClassificationData, ThrowOnError>): RequestResult<UpdateClassificationResponses, UpdateClassificationErrors, ThrowOnError> => (options.client ?? client).patch<UpdateClassificationResponses, UpdateClassificationErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateClassificationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/{classification_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Classification File
 *
 * Get signed URL for viewing the classification's source file.
 */
export const getClassificationFile = <ThrowOnError extends boolean = false>(options: Options<GetClassificationFileData, ThrowOnError>): RequestResult<GetClassificationFileResponses, GetClassificationFileErrors, ThrowOnError> => (options.client ?? client).get<GetClassificationFileResponses, GetClassificationFileErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetClassificationFileResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/{classification_uuid}/file',
    ...options
});

/**
 * Review Classification
 *
 * Review a classification — validate or reject.
 */
export const reviewClassification = <ThrowOnError extends boolean = false>(options: Options<ReviewClassificationData, ThrowOnError>): RequestResult<ReviewClassificationResponses, ReviewClassificationErrors, ThrowOnError> => (options.client ?? client).post<ReviewClassificationResponses, ReviewClassificationErrors, ThrowOnError>({
    responseValidator: async (data) => await zReviewClassificationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/{classification_uuid}/actions/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve Duplicate
 *
 * Resolve a duplicate pair — keep one classification, discard the other.
 */
export const resolveDuplicate = <ThrowOnError extends boolean = false>(options: Options<ResolveDuplicateData, ThrowOnError>): RequestResult<ResolveDuplicateResponses, ResolveDuplicateErrors, ThrowOnError> => (options.client ?? client).post<ResolveDuplicateResponses, ResolveDuplicateErrors, ThrowOnError>({
    responseValidator: async (data) => await zResolveDuplicateResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/actions/resolve-duplicate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk Delete Classifications
 *
 * Soft-delete several classifications in one request — fase4-fixes.md B4.
 *
 * The reviewer multi-selects rows in the review queue and confirms the
 * delete in a single round-trip; the endpoint preserves per-UUID
 * semantics (silently skipping missing ones) so the frontend can render
 * an informative toast. GCS blob cleanup is deferred to a background
 * task so the response returns as soon as the DB soft-deletes commit.
 */
export const bulkDeleteClassifications = <ThrowOnError extends boolean = false>(options: Options<BulkDeleteClassificationsData, ThrowOnError>): RequestResult<BulkDeleteClassificationsResponses, BulkDeleteClassificationsErrors, ThrowOnError> => (options.client ?? client).post<BulkDeleteClassificationsResponses, BulkDeleteClassificationsErrors, ThrowOnError>({
    responseValidator: async (data) => await zBulkDeleteClassificationsResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/actions/bulk-delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk Reclassify Classifications
 *
 * Reset and re-queue several classifications in one request.
 *
 * The reset and its reprocess event commit atomically through the outbox;
 * the dispatcher publishes after commit, so delivery is guaranteed and
 * there is no per-row publish failure to report.
 */
export const bulkReclassifyClassifications = <ThrowOnError extends boolean = false>(options: Options<BulkReclassifyClassificationsData, ThrowOnError>): RequestResult<BulkReclassifyClassificationsResponses, BulkReclassifyClassificationsErrors, ThrowOnError> => (options.client ?? client).post<BulkReclassifyClassificationsResponses, BulkReclassifyClassificationsErrors, ThrowOnError>({
    responseValidator: async (data) => await zBulkReclassifyClassificationsResponse2.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/actions/bulk-reclassify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Classification Locks
 *
 * Active ground-truth locks plus the lockable-field catalogue for this
 * document's type — drives the reprocess modal's form.
 */
export const getClassificationLocks = <ThrowOnError extends boolean = false>(options: Options<GetClassificationLocksData, ThrowOnError>): RequestResult<GetClassificationLocksResponses, GetClassificationLocksErrors, ThrowOnError> => (options.client ?? client).get<GetClassificationLocksResponses, GetClassificationLocksErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetClassificationLocksResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/{classification_uuid}/locks',
    ...options
});

/**
 * Reclassify Classification
 *
 * Reset a classification and re-trigger the pipeline.
 *
 * With a body, the ``locks`` list REPLACES the document's ground-truth lock
 * set; without a body, existing sticky locks are preserved.
 */
export const reclassifyClassification = <ThrowOnError extends boolean = false>(options: Options<ReclassifyClassificationData, ThrowOnError>): RequestResult<ReclassifyClassificationResponses, ReclassifyClassificationErrors, ThrowOnError> => (options.client ?? client).post<ReclassifyClassificationResponses, ReclassifyClassificationErrors, ThrowOnError>({
    responseValidator: async (data) => await zReclassifyClassificationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/beneficiaries/{beneficiary_uuid}/classifications/{classification_uuid}/actions/reclassify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Dashboard Stats
 *
 * Get admin dashboard statistics (platform admin only).
 *
 * Uses efficient COUNT queries instead of loading all entities into memory.
 */
export const getDashboardStats = <ThrowOnError extends boolean = false>(options?: Options<GetDashboardStatsData, ThrowOnError>): RequestResult<GetDashboardStatsResponses, GetDashboardStatsErrors, ThrowOnError> => (options?.client ?? client).get<GetDashboardStatsResponses, GetDashboardStatsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetDashboardStatsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/dashboard',
    ...options
});

/**
 * List Users
 *
 * List all users with optional filtering.
 */
export const listUsers = <ThrowOnError extends boolean = false>(options?: Options<ListUsersData, ThrowOnError>): RequestResult<ListUsersResponses, ListUsersErrors, ThrowOnError> => (options?.client ?? client).get<ListUsersResponses, ListUsersErrors, ThrowOnError>({
    responseValidator: async (data) => await zListUsersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users',
    ...options
});

/**
 * Get User By Uuid
 *
 * Get a specific user by UUID.
 */
export const getUserByUuid = <ThrowOnError extends boolean = false>(options: Options<GetUserByUuidData, ThrowOnError>): RequestResult<GetUserByUuidResponses, GetUserByUuidErrors, ThrowOnError> => (options.client ?? client).get<GetUserByUuidResponses, GetUserByUuidErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetUserByUuidResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_uuid}',
    ...options
});

/**
 * Toggle User Status
 *
 * Toggle user active/inactive status (platform admin only).
 * If user is active, deactivate them. If inactive, activate them.
 */
export const toggleUserStatus = <ThrowOnError extends boolean = false>(options: Options<ToggleUserStatusData, ThrowOnError>): RequestResult<ToggleUserStatusResponses, ToggleUserStatusErrors, ThrowOnError> => (options.client ?? client).patch<ToggleUserStatusResponses, ToggleUserStatusErrors, ThrowOnError>({
    responseValidator: async (data) => await zToggleUserStatusResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_uuid}/status',
    ...options
});

/**
 * Get User Memberships
 *
 * Get all memberships for a specific user (platform admin only).
 * Returns list of organizations the user belongs to with their roles.
 */
export const getUserMemberships = <ThrowOnError extends boolean = false>(options: Options<GetUserMembershipsData, ThrowOnError>): RequestResult<GetUserMembershipsResponses, GetUserMembershipsErrors, ThrowOnError> => (options.client ?? client).get<GetUserMembershipsResponses, GetUserMembershipsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetUserMembershipsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_uuid}/memberships',
    ...options
});

/**
 * Send Reset Password Email
 *
 * Send password reset email to user (platform admin only).
 * This triggers the standard password reset flow - user receives
 * an email with a link to set a new password.
 */
export const sendResetPasswordEmail = <ThrowOnError extends boolean = false>(options: Options<SendResetPasswordEmailData, ThrowOnError>): RequestResult<SendResetPasswordEmailResponses, SendResetPasswordEmailErrors, ThrowOnError> => (options.client ?? client).post<SendResetPasswordEmailResponses, SendResetPasswordEmailErrors, ThrowOnError>({
    responseValidator: async (data) => await zSendResetPasswordEmailResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/users/{user_uuid}/send-reset-password-email',
    ...options
});

/**
 * List All Organizations
 *
 * List all organizations
 */
export const listAllOrganizations = <ThrowOnError extends boolean = false>(options?: Options<ListAllOrganizationsData, ThrowOnError>): RequestResult<ListAllOrganizationsResponses, ListAllOrganizationsErrors, ThrowOnError> => (options?.client ?? client).get<ListAllOrganizationsResponses, ListAllOrganizationsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListAllOrganizationsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations',
    ...options
});

/**
 * Create Organization
 *
 * Create a new organization (platform admin only)
 */
export const createOrganization = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationData, ThrowOnError>): RequestResult<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError>({
    responseValidator: async (data) => await zCreateOrganizationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Delete Organization
 *
 * Delete organization (platform admin only)
 */
export const adminDeleteOrganization = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteOrganizationData, ThrowOnError>): RequestResult<AdminDeleteOrganizationResponses, AdminDeleteOrganizationErrors, ThrowOnError> => (options.client ?? client).delete<AdminDeleteOrganizationResponses, AdminDeleteOrganizationErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminDeleteOrganizationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{organization_uuid}',
    ...options
});

/**
 * Get Organization By Uuid
 *
 * Get a specific organization by UUID (platform admin only)
 */
export const getOrganizationByUuid = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationByUuidData, ThrowOnError>): RequestResult<GetOrganizationByUuidResponses, GetOrganizationByUuidErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationByUuidResponses, GetOrganizationByUuidErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetOrganizationByUuidResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{organization_uuid}',
    ...options
});

/**
 * Admin Update Organization
 *
 * Update an organization (platform admin only)
 */
export const adminUpdateOrganization = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateOrganizationData, ThrowOnError>): RequestResult<AdminUpdateOrganizationResponses, AdminUpdateOrganizationErrors, ThrowOnError> => (options.client ?? client).patch<AdminUpdateOrganizationResponses, AdminUpdateOrganizationErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminUpdateOrganizationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{organization_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Invite User
 *
 * Invite user to organization
 */
export const adminInviteUser = <ThrowOnError extends boolean = false>(options: Options<AdminInviteUserData, ThrowOnError>): RequestResult<AdminInviteUserResponses, AdminInviteUserErrors, ThrowOnError> => (options.client ?? client).post<AdminInviteUserResponses, AdminInviteUserErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminInviteUserResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{organization_uuid}/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Invitations
 *
 * List invitations for an organization
 */
export const listInvitations = <ThrowOnError extends boolean = false>(options: Options<ListInvitationsData, ThrowOnError>): RequestResult<ListInvitationsResponses, ListInvitationsErrors, ThrowOnError> => (options.client ?? client).get<ListInvitationsResponses, ListInvitationsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListInvitationsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{organization_uuid}/invitations',
    ...options
});

/**
 * Admin Delete Organization Invitation
 *
 * Delete invitation
 */
export const adminDeleteOrganizationInvitation = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteOrganizationInvitationData, ThrowOnError>): RequestResult<AdminDeleteOrganizationInvitationResponses, AdminDeleteOrganizationInvitationErrors, ThrowOnError> => (options.client ?? client).delete<AdminDeleteOrganizationInvitationResponses, AdminDeleteOrganizationInvitationErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminDeleteOrganizationInvitationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{organization_uuid}/invitations/{invitation_uuid}',
    ...options
});

/**
 * List Members
 *
 * List members of an organization
 */
export const listMembers = <ThrowOnError extends boolean = false>(options: Options<ListMembersData, ThrowOnError>): RequestResult<ListMembersResponses, ListMembersErrors, ThrowOnError> => (options.client ?? client).get<ListMembersResponses, ListMembersErrors, ThrowOnError>({
    responseValidator: async (data) => await zListMembersResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{organization_uuid}/members',
    ...options
});

/**
 * Admin Delete Membership
 *
 * Remove a member from an organization (platform admin only)
 */
export const adminDeleteMembership = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteMembershipData, ThrowOnError>): RequestResult<AdminDeleteMembershipResponses, AdminDeleteMembershipErrors, ThrowOnError> => (options.client ?? client).delete<AdminDeleteMembershipResponses, AdminDeleteMembershipErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminDeleteMembershipResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/memberships/{membership_uuid}',
    ...options
});

/**
 * Admin Update Membership
 *
 * Update a membership role or status (platform admin only)
 */
export const adminUpdateMembership = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateMembershipData, ThrowOnError>): RequestResult<AdminUpdateMembershipResponses, AdminUpdateMembershipErrors, ThrowOnError> => (options.client ?? client).patch<AdminUpdateMembershipResponses, AdminUpdateMembershipErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminUpdateMembershipResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/memberships/{membership_uuid}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Create Invitation
 *
 * Create an invitation (platform admin only).
 * Resolves the user name and invitation type automatically.
 */
export const adminCreateInvitation = <ThrowOnError extends boolean = false>(options: Options<AdminCreateInvitationData, ThrowOnError>): RequestResult<AdminCreateInvitationResponses, AdminCreateInvitationErrors, ThrowOnError> => (options.client ?? client).post<AdminCreateInvitationResponses, AdminCreateInvitationErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminCreateInvitationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin Resend Invitation
 *
 * Resend a pending invitation (platform admin only)
 */
export const adminResendInvitation = <ThrowOnError extends boolean = false>(options: Options<AdminResendInvitationData, ThrowOnError>): RequestResult<AdminResendInvitationResponses, AdminResendInvitationErrors, ThrowOnError> => (options.client ?? client).patch<AdminResendInvitationResponses, AdminResendInvitationErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminResendInvitationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/invitations/{invitation_uuid}/resend',
    ...options
});

/**
 * Admin Delete Invitation
 *
 * Delete/cancel an invitation (platform admin only)
 */
export const adminDeleteInvitation = <ThrowOnError extends boolean = false>(options: Options<AdminDeleteInvitationData, ThrowOnError>): RequestResult<AdminDeleteInvitationResponses, AdminDeleteInvitationErrors, ThrowOnError> => (options.client ?? client).delete<AdminDeleteInvitationResponses, AdminDeleteInvitationErrors, ThrowOnError>({
    responseValidator: async (data) => await zAdminDeleteInvitationResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/invitations/{invitation_uuid}',
    ...options
});

/**
 * List Entitlements
 *
 * List an organization's module entitlements with their evaluated quota states.
 */
export const listEntitlements = <ThrowOnError extends boolean = false>(options: Options<ListEntitlementsData, ThrowOnError>): RequestResult<ListEntitlementsResponses, ListEntitlementsErrors, ThrowOnError> => (options.client ?? client).get<ListEntitlementsResponses, ListEntitlementsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListEntitlementsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{organization_uuid}/entitlements',
    ...options
});

/**
 * Grant Entitlement
 *
 * Grant a module to an organization (platform admin only).
 */
export const grantEntitlement = <ThrowOnError extends boolean = false>(options: Options<GrantEntitlementData, ThrowOnError>): RequestResult<GrantEntitlementResponses, GrantEntitlementErrors, ThrowOnError> => (options.client ?? client).post<GrantEntitlementResponses, GrantEntitlementErrors, ThrowOnError>({
    responseValidator: async (data) => await zGrantEntitlementResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{organization_uuid}/entitlements',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Entitlement
 *
 * Update an entitlement's quotas, activation, or expiry (platform admin only).
 */
export const updateEntitlement = <ThrowOnError extends boolean = false>(options: Options<UpdateEntitlementData, ThrowOnError>): RequestResult<UpdateEntitlementResponses, UpdateEntitlementErrors, ThrowOnError> => (options.client ?? client).patch<UpdateEntitlementResponses, UpdateEntitlementErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateEntitlementResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{organization_uuid}/entitlements/{module_code}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset Entitlement Quota
 *
 * Reset a module's usage window (support action), keeping usage history.
 */
export const resetEntitlementQuota = <ThrowOnError extends boolean = false>(options: Options<ResetEntitlementQuotaData, ThrowOnError>): RequestResult<ResetEntitlementQuotaResponses, ResetEntitlementQuotaErrors, ThrowOnError> => (options.client ?? client).post<ResetEntitlementQuotaResponses, ResetEntitlementQuotaErrors, ThrowOnError>({
    responseValidator: async (data) => await zResetEntitlementQuotaResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{organization_uuid}/entitlements/{module_code}/reset',
    ...options
});

/**
 * Get Organization Usage
 *
 * Per-domain usage for an organization over a period (default: current month).
 */
export const getOrganizationUsage = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationUsageData, ThrowOnError>): RequestResult<GetOrganizationUsageResponses, GetOrganizationUsageErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationUsageResponses, GetOrganizationUsageErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetOrganizationUsageResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/organizations/{organization_uuid}/usage',
    ...options
});

/**
 * List My Profiles
 *
 * List all investor profiles available to the current user.
 */
export const listMyProfiles = <ThrowOnError extends boolean = false>(options?: Options<ListMyProfilesData, ThrowOnError>): RequestResult<ListMyProfilesResponses, ListMyProfilesErrors, ThrowOnError> => (options?.client ?? client).get<ListMyProfilesResponses, ListMyProfilesErrors, ThrowOnError>({
    responseValidator: async (data) => await zListMyProfilesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hub/investor/profiles',
    ...options
});

/**
 * Get My Profile
 *
 * Get the current user's investor profile.
 */
export const getMyProfile = <ThrowOnError extends boolean = false>(options?: Options<GetMyProfileData, ThrowOnError>): RequestResult<GetMyProfileResponses, GetMyProfileErrors, ThrowOnError> => (options?.client ?? client).get<GetMyProfileResponses, GetMyProfileErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetMyProfileResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hub/investor/profile',
    ...options
});

/**
 * Update My Profile
 *
 * Update the current user's investor profile (limited fields).
 */
export const updateMyProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateMyProfileData, ThrowOnError>): RequestResult<UpdateMyProfileResponses, UpdateMyProfileErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMyProfileResponses, UpdateMyProfileErrors, ThrowOnError>({
    responseValidator: async (data) => await zUpdateMyProfileResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hub/investor/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List My Investments
 *
 * List investments for the current investor.
 */
export const listMyInvestments = <ThrowOnError extends boolean = false>(options?: Options<ListMyInvestmentsData, ThrowOnError>): RequestResult<ListMyInvestmentsResponses, ListMyInvestmentsErrors, ThrowOnError> => (options?.client ?? client).get<ListMyInvestmentsResponses, ListMyInvestmentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListMyInvestmentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hub/investor/investments',
    ...options
});

/**
 * Get My Investment
 *
 * Get detailed view of a specific investment (ownership verified).
 */
export const getMyInvestment = <ThrowOnError extends boolean = false>(options: Options<GetMyInvestmentData, ThrowOnError>): RequestResult<GetMyInvestmentResponses, GetMyInvestmentErrors, ThrowOnError> => (options.client ?? client).get<GetMyInvestmentResponses, GetMyInvestmentErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetMyInvestmentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hub/investor/investments/{investment_uuid}',
    ...options
});

/**
 * Get My Dashboard
 *
 * Get dashboard summary with investment statistics and recent activity.
 */
export const getMyDashboard = <ThrowOnError extends boolean = false>(options?: Options<GetMyDashboardData, ThrowOnError>): RequestResult<GetMyDashboardResponses, GetMyDashboardErrors, ThrowOnError> => (options?.client ?? client).get<GetMyDashboardResponses, GetMyDashboardErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetMyDashboardResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hub/investor/dashboard',
    ...options
});

/**
 * Get My Pending Actions
 *
 * Get all pending actions for the investor.
 *
 * Returns:
 * - contracts_to_sign: Contracts awaiting investor signature
 * - pending_payments: Investments needing payment upload
 * - expiring_reservations: Reservations expiring within the threshold
 */
export const getMyPendingActions = <ThrowOnError extends boolean = false>(options?: Options<GetMyPendingActionsData, ThrowOnError>): RequestResult<GetMyPendingActionsResponses, GetMyPendingActionsErrors, ThrowOnError> => (options?.client ?? client).get<GetMyPendingActionsResponses, GetMyPendingActionsErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetMyPendingActionsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hub/investor/pending-actions',
    ...options
});

/**
 * Get My Documents Portfolio
 *
 * Return every document relevant to the current investor.
 *
 * Same shape and filters as the admin-facing
 * ``GET /investors/{uuid}/documents`` endpoint, but scoped implicitly to the
 * logged-in investor via the hub auth dependency. The investor sees:
 *
 * - ``owned``: their own KYC / personal docs (passport, national_id, ...)
 * - ``from_investments``: docs of every investment they are party of,
 * grouped per investment with reference, amount, state and beneficiary name.
 */
export const getMyDocumentsPortfolio = <ThrowOnError extends boolean = false>(options?: Options<GetMyDocumentsPortfolioData, ThrowOnError>): RequestResult<GetMyDocumentsPortfolioResponses, GetMyDocumentsPortfolioErrors, ThrowOnError> => (options?.client ?? client).get<GetMyDocumentsPortfolioResponses, GetMyDocumentsPortfolioErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetMyDocumentsPortfolioResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hub/investor/documents',
    ...options
});

/**
 * List My Investment Documents
 *
 * List all documents for a specific investment (investor portal).
 */
export const listMyInvestmentDocuments = <ThrowOnError extends boolean = false>(options: Options<ListMyInvestmentDocumentsData, ThrowOnError>): RequestResult<ListMyInvestmentDocumentsResponses, ListMyInvestmentDocumentsErrors, ThrowOnError> => (options.client ?? client).get<ListMyInvestmentDocumentsResponses, ListMyInvestmentDocumentsErrors, ThrowOnError>({
    responseValidator: async (data) => await zListMyInvestmentDocumentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hub/investor/investments/{investment_uuid}/documents',
    ...options
});

/**
 * Download My Investment Document
 *
 * Get a signed URL for downloading a specific document (investor portal).
 */
export const downloadMyInvestmentDocument = <ThrowOnError extends boolean = false>(options: Options<DownloadMyInvestmentDocumentData, ThrowOnError>): RequestResult<DownloadMyInvestmentDocumentResponses, DownloadMyInvestmentDocumentErrors, ThrowOnError> => (options.client ?? client).get<DownloadMyInvestmentDocumentResponses, DownloadMyInvestmentDocumentErrors, ThrowOnError>({
    responseValidator: async (data) => await zDownloadMyInvestmentDocumentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hub/investor/investments/{investment_uuid}/documents/{document_uuid}/download',
    ...options
});

/**
 * Get Document Signing Url
 *
 * Get embedded signing URL for a document.
 *
 * Returns either a redirect-based URL (DocuSign) or an embeddable
 * iframe URL (DocuSeal) depending on the signature provider.
 *
 * The signer is resolved against both the authenticated user's email and
 * the investor record's email — with joint administrators, each signs
 * through their own email identity, not the company mailbox.
 */
export const getDocumentSigningUrl = <ThrowOnError extends boolean = false>(options: Options<GetDocumentSigningUrlData, ThrowOnError>): RequestResult<GetDocumentSigningUrlResponses, GetDocumentSigningUrlErrors, ThrowOnError> => (options.client ?? client).post<GetDocumentSigningUrlResponses, GetDocumentSigningUrlErrors, ThrowOnError>({
    responseValidator: async (data) => await zGetDocumentSigningUrlResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hub/investor/investments/{investment_uuid}/documents/{document_uuid}/signing-url',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Payment Receipt
 *
 * Upload a payment receipt for an investment.
 *
 * The investor uploads proof of payment which will be reviewed by the organization.
 * Review starts as PENDING (investor upload, not auto-approved).
 *
 * Accepted formats: PDF, PNG, JPG, JPEG
 */
export const uploadPaymentReceipt = <ThrowOnError extends boolean = false>(options: Options<UploadPaymentReceiptData, ThrowOnError>): RequestResult<UploadPaymentReceiptResponses, UploadPaymentReceiptErrors, ThrowOnError> => (options.client ?? client).post<UploadPaymentReceiptResponses, UploadPaymentReceiptErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseValidator: async (data) => await zUploadPaymentReceiptResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/hub/investor/investments/{investment_uuid}/payment-receipt',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});
